<template>
  <div class="productDetail-container">
    <!-- <store :shopId="collectData.shopId"></store> -->
    <div style="background: #fff">
      <div>
        <div class="shop">
          <!-- <div class="shopLogo" @click="goStore()">
        <img :src="curShop.shopLogo" alt />
        </div>-->
          <div class="toutou">
            <div
              class="warp"
              style="
                display: flex;
                justify-content: left;
                padding: 20px 0;
                margin-top: 20px;
              "
            >
              <div>
                <img
                  src="../../assets/images/dlogo.png"
                  alt
                  class="logo"
                  @click="gotoIndex"
                />
              </div>
              <div
                style="
                  width: 2px;
                  height: 40px;
                  background-color: #eeeff1;
                  margin: 10px 20px;
                "
              ></div>

              <div
                class="menu"
                @mouseover="
                  $route.name !== 'index' ? (showClassify2 = true) : null
                "
                @mouseout="showClassify2 = false"
              >
                <div class="menu-flag">
                  <div>
                    <span>商品分类</span>
                  </div>
                  <span
                    class="el-icon-arrow-right"
                    style="margin-left: 4px; margin-top: 2px"
                    :class="`${showClassify2 ? 'turnDown' : 'turnDown2'}`"
                  ></span>
                  <div
                    v-show="showClassify2"
                    class="classify-outer"
                    @mouseout="showClassify2 = true"
                    style="
                      background-color: #fff;
                      z-index: 999;
                      margin-top: -12px;
                    "
                  >
                    <cere-classification
                      style="height: auto !important"
                      :componentContent="componentContent[0].componentContent"
                    ></cere-classification>
                  </div>
                </div>
                <!-- {{componentContent[0]}} -->
                <!-- <ul>
                    <li
                      v-for="(item, index) in componentContent[0].labelList"
                      :key="index"
                    >
                      <a
                        :class="{ active: isActiisAve(item.name) }"
                        @click="jumpLink(item.linkObj)"
                        >{{ item.name }}</a
                      >
                    </li>
                  </ul>-->
              </div>
              <div class="searchright">
                <div
                  style="
                    display: flex;
                    justify-content: right;
                    height: 60px !important;
                  "
                >
                  <el-input
                    size="large"
                    class="shuru"
                    placeholder="请输入内容"
                    prefix-icon="el-icon-search"
                    v-model="searchFrom.search"
                  ></el-input>
                  <!-- <div class="serachBtn"> prefix-icon="el-icon-user-solid" -->
                  <div class="quanzhan">
                    <el-button
                      type="primary"
                      class="qzBtn"
                      @click="getAllProduct"
                      >搜全站</el-button
                    >
                  </div>
                </div>

                <div class="bendain">
                  <el-button type="info" class="bdBtn" @click="getInfoProduct"
                    >搜本店</el-button
                  >
                </div>
                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="shopHeaderBj">
            <div class="shop1">
              <!-- <div class="shopLogo">
              <img v-if="shopLogo" :src="shopLogo" alt="" />
              <img v-else src="../../assets/images/logo.png" alt="" />
            </div> -->
              <div
                class="warp"
                style="padding: 20px 0 0 20px; position: relative"
              >
                <div class="shopInfo-box">
                  <div class="shopHeard">
                    <div style="display: flex; justify-content: left">
                      <div>
                        <h2 class="shopName" @click="goStore()">
                          {{ curShop.shopName }}
                        </h2>
                      </div>

                      <div
                        class="guanzhu"
                        @click.stop="collectShop"
                        :style="
                          isCare == 0
                            ? ''
                            : 'background-color: rgba(255, 71, 71, 1);color: #fff;'
                        "
                      >
                        {{ isCare == 0 ? "关注" : "已关注" }}
                      </div>
                      <div
                        class="shopCode"
                        style="
                          margin-left: 20px;
                          cursor: pointer;
                          position: relative;
                        "
                      >
                        <img
                          style="width: 30px; margin-top: 8px"
                          src="@/assets/images/shopCode.png"
                          alt=""
                          @mouseout="shopCode = false"
                          @mouseover="shopCode = true"
                        />
                        <div
                          v-if="shopCode == true"
                          style="
                            position: absolute;
                            top: 0px;
                            left: 50px;
                            z-index: 1000;
                            background: #ffffff;
                            width: 250px;
                            height: 250px;
                            text-align: center;
                            padding: 10px;
                            box-shadow: 0px 5px 10px 0px
                              rgba(231, 234, 235, 0.93);
                            border-radius: 4px;
                          "
                        >
                          <vue-qr
                            
                            :size="200"
                            :margin="0"
                            :auto-color="true"
                            :dot-scale="1"
                            :text="appSrc"
                          />
                          <div
                            style="
                              width: 100%;
                              text-align: center;
                              margin-top: 5px;
                            "
                          >
                            店铺二维码（手机APP扫码）
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="information">
                      <img
                        class="renzheng"
                        src="../../assets/images/renzheng.png"
                        alt
                      />
                      <!-- <img
                        class="qiye"
                        src="../../assets/images/qiye.png"
                        alt=""
                      />
                      <span class="qiyeAge">一年</span> -->

                      <span class="dizhi">
                        <i
                          class="icon-positioning"
                          style="
                            color: #fb7600;
                            font-size: 20px;
                            margin-right: 5px;
                          "
                        ></i>
                        {{ this.adressForm.shopAdress }}</span
                      >
                    </div>
                  </div>
                  <div
                    style="
                      width: 550px;
                      font-size: 24px;
                      font-weight: bold;
                      color: #864c17;
                      position: absolute;
                      top: 50px;
                      left: 45%;
                    "
                  >
                    严选优质商品&emsp; 直供源价好货
                  </div>

                  <div style="margin-top: 15px">
                    <div class="block11">
                      <img
                        class="img1"
                        referrerpolicy="no-referrer"
                        src="../../assets/images/tel.png"
                      />
                      <div style="margin-top: 5px; margin-left: 10px">
                        <span
                          style="font-size: 16px; color: #333"
                          class="info34"
                          >店铺服务热线:</span
                        >
                        <span style="font-size: 18px; color: #333">{{
                          formData.chargePersonPhone
                        }}</span>
                      </div>
                    </div>

                    <!-- <div
                class="information"
                @mouseover="showShopInfo = true"
                @mouseout="showShopInfo = false"
              >
                
                <img class="qiye" src="../../assets/images/qiye.png" alt="" />
                <span class="qiyeAge">一年</span>
                <img
                  class="dingwei"
                  src="../../assets/images/dingwei.png"
                  alt=""
                />
                <span class="dizhi"> {{ this.adressForm.shopAdress }}</span>
                <span class="chanpin">主营产品：<nbsp />{{ shopName }}</span>

                <div class="infomokuai" v-show="showShopInfo">
                  <div>
                    <el-card class="box-card" style="width: 400px">
                      <div slot="header" class="clearfix">
                        <div class="a">
                          <span
                            style="
                              font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                              font-weight: bold;
                              font-size: 26px;
                              color: #333333;
                              line-height: 26px;
                            "
                            >{{ this.adressForm.shopAdress }}</span
                          >
                        </div>
                        <div class="b">
                          <img
                            style="width: 19px; height: 24px; padding-top: 2px"
                            src="../../assets/images/qiye.png"
                            alt=""
                          />
                        </div>
                        <div class="c"><span>一年</span></div>
                      </div>
                      <div class="qiyerenzheng">
                        <div class="d">
                          <span class="font-size:19px">法人代表：李四</span>
                          <span class="font-size:19px">商品数量：90</span>
                        </div>
                        <div class="d">
                          <span class="font-size:19px"
                            >成立时间：2021-9-21</span
                          >
                          <span class="font-size:19px"
                            >等级机关：隆阳区市场监督管理局</span
                          >
                        </div>
                      </div>
                    </el-card>
                  </div>
                </div>
                </div>-->
                    <!-- <span
                >信誉
                <img
                  v-for="i in 5"
                  :key="i"
                  src="../../assets/images/diamond.png"
                  alt=""
                  srcset=""
                /></span>-->
                  </div>

                  <!-- <div
              class="block12"
              @mouseover="showShopWechat = true"
              @mouseout="showShopWechat = false"
            >
              <img
                class="bd26 flex-col"
                src="../../assets/images/erweima.png"
                alt=""
              />
              <span class="info35">店主微信</span>
              <div class="erweimamokuai" v-show="showShopWechat">
                <el-card
                  style="width: 250px; height: 249px; text-align: center"
                >
                  <div>
                    <img
                      style="width: 182px; height: 187px; margin: 0 auto"
                      src="../../assets/images/erweima.png"
                      alt=""
                      srcset=""
                    />
                    <div>
                      <span style="width: 100%; font-size: 14px"
                        >扫一扫二维码添加店主微信</span
                      >
                    </div>
                  </div>
                </el-card>
              </div>
              </div>-->
                </div>
              </div>
            </div>
          </div>
          <!-- <span
          >信誉
          
          <img
            v-for="i in 5"
            :key="i"
            src="../../assets/images/diamond.png"
            alt=""
            srcset=""
          /></span> -->
          <!-- <div class="shopInfo">
        <div class="favoritesBox cur-poi" @click="collectShop">
          <img
            style="width: 18px; height: 18px"
            v-if="collectData.ifCollect === 0"
            src="../../../static/image/sc0.png"
            alt=""
          />
          <img
            style="width: 18px; height: 18px"
            v-else
            src="../../../static/image/sc1.png"
            alt=""
          />
          <div class="text">收藏店铺</div>
        </div>
        </div>-->
        </div>
      </div>
    </div>
    <div class="el-tab-box">
      <el-tabs class="tabs warp" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="首页" name="index"></el-tab-pane>
        <!-- <el-tab-pane label="所有商品" name="all"></el-tab-pane> -->
        <el-tab-pane
          style="position: relative"
          label="产品分类"
          name="shopClassifyList"
        >
          <div
            style="display: inline-block; height: 100%"
            slot="label"
            @mouseover="showMenu = true"
            @mouseleave="showMenu = false"
          >
            产品分类
            <i
              :class="
                showMenu
                  ? 'el-icon-caret-bottom selectMenu'
                  : 'el-icon-caret-bottom'
              "
            ></i>
            <div v-if="showMenu" slot="label" class="ShopMenu">
              <div class="menuall">
                <div style="border-right: 1px solid #e5e5e5">
                  <div
                    class="menuItem"
                    v-for="(item, index) in categoryItem"
                    :key="index"
                    @mouseover="getChildren(item)"
                    @mouseleave="clianChildren"
                    @click.stop="handleClickMenu(item)"
                  >
                    <span>{{ item.classifyName }}</span>
                    <i
                      style="margin-left: 10px"
                      :class="
                        showMenu2
                          ? 'el-icon-arrow-right selectMenu2'
                          : 'el-icon-arrow-right'
                      "
                    ></i>
                  </div>
                </div>

                <div style="background-color: #fff; color: #000">
                  <div class="hoverBox">
                    <div
                      class="dl"
                      v-for="(subItem, index) in menuChildren.childs"
                      :key="index"
                    >
                      <div class="dt" style="cursor: pointer">
                        <span
                          @click.stop="
                            goStoreClassifyDetail(subItem.classifyId)
                          "
                          >{{ subItem.classifyName }}</span
                        >
                      </div>
                      <div class="dd">
                        <a
                          class="a-link"
                          v-for="(threeItem, index) in subItem.childs"
                          :key="index"
                        >
                          <span
                            @click.stop="
                              goStoreClassifyDetail(threeItem.classifyId)
                            "
                            >{{ threeItem.classifyName }}</span
                          >
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- <i class="el-icon-arrow-down cur-poi el-icon--right"></i> -->
        <el-tab-pane label="公司档案" name="dossier"></el-tab-pane>
        <el-tab-pane label="联系我们" name="contact"></el-tab-pane>
        <!-- <el-tab-pane :label="item.classifyName" v-for="item in shopClassifyList" :key="item.classifyId" :name="item.classifyId.toString()" ></el-tab-pane> -->
      </el-tabs>
    </div>
    <!-- <div class="menu">
      <div
        class="menu-flag"
        @mouseleave="showClassify = false"
        @mouseenter="$route.name !== 'index' ? (showClassify = true) : null"
      >
        <div>
          <span>商品分类</span>
        </div>
        <span
          class="el-icon-arrow-right"
          style="margin-left: 4px; margin-top: 2px"
          :class="`${showClassify ? 'turnDown' : ''}`"
        ></span>
        <div
          class="classify-outer"
          :class="`${showClassify ? 'showClassify' : ''}`"
        >
          <cere-classification
            :componentContent="componentContent[0].componentContent"
          ></cere-classification>
        </div>
      </div>
    </div>-->
    <!-- <div class="classify-bar warp">
      <span name="all" @click="goStore('all')">所有商品</span>
      <span
        v-for="item in shopClassifyList"
        :key="item.classifyId"
        @click="goStore(item.classifyId.toString())"
        >{{ item.classifyName }}</span
      >
      style="border: 1px solid #e4e4e4"
    </div>-->
    <div class="productBox warp">
      <div class="productConcise clearfix">
        <div class="swiper-box">
          <!-- swiper1 -->
          <swiper
            :options="swiperOptionTop"
            class="gallery-top"
            ref="swiperTop"
            style="border: 1px solid #e4e4e4"
          >
            <swiper-slide
              v-for="item of productDetailData.images"
              :key="item"
              style="text-align: center"
            >
              <img :src="item" alt style="height: 100%; width: auto" />
            </swiper-slide>
          </swiper>
          <!-- swiper2 Thumbs -->
          <div class="swiperThumbsLeft">
            <div class="thumbsBox">
              <swiper
                :options="swiperOptionThumbs"
                class="gallery-thumbs"
                ref="swiperThumbs"
              >
                <swiper-slide
                  v-for="(item, index) of productDetailData.images"
                  :key="index"
                  :img="item"
                >
                  <!-- :style="{ backgroundImage: 'url(' + item + ')' }" -->
                  <img :src="item" alt srcset />
                  <!-- {{item}} -->
                  <!-- <div
                    style="width: 100%; height: 100%"
                    @click="thumbsClick(index)"
                  ></div>-->
                </swiper-slide>
              </swiper>
              <div class="image-button-prev" slot="button-prev">
                <a-icon type="left" />
              </div>
              <div class="image-button-next" slot="button-next">
                <a-icon type="right" />
              </div>
            </div>
          </div>
          <div 
              style="
              display: flex;
              justify-content: left;
              width: 440px;
              padding-left: 10px;
              margin-bottom: -30px;
              margin-top: 50px;
            "
          >
            <!-- <div class="server">
              <span>
                <img src="../../assets/images/wangwang.png" alt />
              </span>
              <span>联系客服</span>
            </div> -->
            <div class="favoritesBtn" @click="collect" title="收藏">
              <!-- <a-icon type="heart" style="font-size: 44px;margin-top: -2px;color: #F77B0B;" v-if="productDetailData.ifCollect === 0"/>
              <a-icon type="heart" theme="filled" style="font-size: 44px;margin-top: -2px;color: #F77B0B;" v-else/>-->
              <span
                :class="`${
                  productDetailData.ifCollect === 0
                    ? 'icon-shoucang'
                    : 'icon-shoucang1'
                }`"
              ></span>
              <!-- <img
                  style="width: 18px; height: 18px"
                  v-if="productDetailData.ifCollect === 0"
                  src="../../../static/image/sc0.png"
                  alt=""
                />
                <img
                  style="width: 18px; height: 18px"
                  v-else
                  src="../../../static/image/sc1.png"
                  alt=""
              />-->
              <span
                v-if="productDetailData.ifCollect === 0"
                style="color: #000000a6"
                >收藏</span
              >
              <span v-else style="color: #000000a6">已收藏</span>
            </div>
          </div>
        </div>

        <!-- <div class="tuijian">
          <img class="pict" src="../../assets/images/zhutuikuan.png" alt="" />
          <div class="lunbo">
            <el-carousel
              type="card"
              indicator-position="outside"
              :autoplay="false"
              arrow="always"
              style="height: 234px; width: 1000px"
            >
              <el-carousel-item v-for="(item, index) in item" :key="index">
                <span style="height: 155px; width: 155px">
                  <img
                    style="height: 155px; width: 155px"
                    :src="item.image"
                    alt=""
                  />
                </span>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>-->
        <a-spin :spinning="spinning">
          <div class="proDuctInfo">
            <h3 class="productTit">{{ productDetailData.productName }}</h3>
            <p class="introduction">{{ productDetailData.productBrief }}</p>
            <div class="priceDataInfo">
              <div v-if="currentProductData.activityType === 1 && false">
                <div class="groupBuyInfo">
                  <div class="groupLeft">
                    <i class="iconfont">&#xe64a;</i>
                    <span>拼团专区</span>
                  </div>
                  <div class="groupRight" v-if="ifEnable === 0">
                    {{ productDetailData.person }}人团
                  </div>
                  <div class="groupRight" v-else>
                    {{ productOption.skuTool.startTime }} 活动开启
                  </div>
                </div>
                <div class="priceSpike mar-bot-20">
                  <div class="priceSpikeLeft">
                    拼团价：
                    <b>￥{{ currentProductData.price }}</b>
                    <span>￥{{ currentProductData.originalPrice }}</span>
                  </div>
                </div>
              </div>
              <div v-if="currentProductData.activityType === 2 && false">
                <div class="groupBuyInfo">
                  <div class="groupLeft">
                    <i class="iconfont">&#xe64a;</i>
                    <span>秒杀专区</span>
                  </div>
                  <div class="countdown" v-if="ifEnable === 0">
                    <div class="countdownTit">距离结束:</div>
                    <div class="timeDown">
                      <span class="time">{{ endTime | formatHours }}</span>
                      <span>:</span>
                      <span class="time">{{ endTime | formatMinutes }}</span>
                      <span>:</span>
                      <span class="time">{{ endTime | formatSeconds }}</span>
                    </div>
                  </div>
                  <div class="groupRight" v-else>
                    {{ productOption.skuTool.startTime }} 活动开启
                  </div>
                </div>
                <div class="priceSpike mar-bot-20">
                  <div class="priceSpikeLeft">
                    秒杀价：
                    <b>￥{{ currentProductData.price }}</b>
                    <span>￥{{ currentProductData.originalPrice }}</span>
                  </div>
                  <div
                    class="priceSpikeRight"
                    v-if="productDetailData.total && ifEnable === 0"
                  >
                    <span>
                      限量{{ productDetailData.total }}件/还剩{{
                        productDetailData.surplusNumber
                      }}件
                    </span>
                    <el-progress
                      :text-inside="true"
                      :stroke-width="10"
                      :percentage="
                        ((productDetailData.total -
                          productDetailData.surplusNumber) /
                          productDetailData.total) *
                        100
                      "
                      status="exception"
                    ></el-progress>
                  </div>
                </div>
              </div>
              <div v-if="currentProductData.activityType === 3 && false">
                <div class="groupBuyInfo">
                  <div class="groupLeft">
                    <i class="iconfont">&#xe64a;</i>
                    <span>限时折扣</span>
                  </div>
                  <div class="countdown" v-if="ifEnable === 0">
                    <div class="countdownTit">距离结束:</div>
                    <div class="timeDown">
                      <span class="time">{{ endTime | formatHours }}</span>
                      <span>:</span>
                      <span class="time">{{ endTime | formatMinutes }}</span>
                      <span>:</span>
                      <span class="time">{{ endTime | formatSeconds }}</span>
                    </div>
                  </div>
                  <div class="groupRight" v-else>
                    {{ productOption.skuTool.startTime }} 活动开启
                  </div>
                </div>
                <div class="priceSpike mar-bot-20">
                  <div class="priceSpikeLeft">
                    折扣价：
                    <b>￥{{ currentProductData.price }}</b>
                    <span>￥{{ currentProductData.originalPrice }}</span>
                  </div>
                  <div
                    class="priceSpikeRight"
                    v-if="productDetailData.total && ifEnable === 0"
                  >
                    <span>
                      限量{{ productDetailData.total }}件/还剩{{
                        productDetailData.surplusNumber
                      }}件
                    </span>
                    <el-progress
                      :text-inside="true"
                      :stroke-width="10"
                      :percentage="
                        ((productDetailData.total -
                          productDetailData.surplusNumber) /
                          productDetailData.total) *
                        100
                      "
                      status="exception"
                    ></el-progress>
                  </div>
                </div>
              </div>
              <!-- <div class="promotionInfo" v-if="currentProductData.activityType===0"> -->
              <div class="promotionInfo">
                <span>价格</span>

                <span>
                  <span>
                    <small>¥</small>
                    <span style="margin-left: -2px">{{
                      currentProductPrice.min
                    }}</span>
                  </span>
                  <template
                    v-if="currentProductPrice.min !== currentProductPrice.max"
                  >
                    <span>-</span>
                    <span>
                      <small>¥</small>
                      <span style="margin-left: -2px">{{
                        currentProductPrice.max
                      }}</span>
                    </span>
                  </template>
                  <!-- {{ currentProductPrice }} -->
                  <!-- {{ currentProductData.price }} -->
                </span>
                <!-- <span>￥{{ currentProductData.originalPrice }}</span> -->
              </div>
              <div class="proDiscount">
                <div
                  class="activityLabel"
                  v-for="(item, index) of productDetailData.markTools"
                  :key="index"
                >
                  <span>{{ item.activityName }}</span>
                  <span>优惠券：{{ item.content }}</span>
                  <span @click="getThisCoupon(item, index)">{{
                    item.state === 3 ? "领取" : "已领取"
                  }}</span>
                </div>
                <div
                  class="activityLabel"
                  v-for="(item, index) of productDetailData.shopMarkTools"
                  :key="index"
                >
                  <span>{{ item.activityName }}</span>
                  <span>优惠券：{{ item.content }}</span>
                  <span @click="getThisCoupon1(item, index)">{{
                    item.state === 3 ? "领取" : "已领取"
                  }}</span>
                </div>
              </div>
            </div>
            <!-- <div class="productColor">
            <div class="proDescribeTit">{{ productColor.skuName }}：</div>
            <div class="proColorList">
             <div :style="{borderColor: productInfo.currentColor === index ? item.value : '#FFF'}" v-for="(item, index) of colorList" :key="index"><span :style="{background: item.value}"></span></div>
              <div :style="{borderColor: productInfo.currentColor === index}" v-for="(item, index) of productOption.map" :key="index"><span><img
                :src="item.image" alt=""></span></div>
            </div>
            </div>-->
            <!-- <div class="productSize">
            <div class="proDescribeTit">码数：</div>
            <div class="proSizeList">
              <span :class="{sizeActive: productInfo.currentSize === index}" v-for="(item, index) of productSize" :key="index">{{item.size}}</span>
            </div>
            </div>-->
            <div class="sku-box">
              <!-- <ul v-for='it in productOption.names' :key='it.nameCode'>
              <li>
                <p class="proDescribeTit">{{it.skuName === '' ? '' : it.skuName + ':'}}</p>
                <p>
                  <span
                    @click='selectSku(kt, it)'
                    v-for='kt in it.values'
                    :key='kt.valueCode'
                    :class="[{'selected-item': kt.selected}]">
                    {{kt.skuValue }}
                  </span>
                </p>
              </li>

              </ul>-->
              <ul>
                <li class="proDescribeTit-parent">
                  <p class="proDescribeTit">
                    {{
                      productOption.names[0].skuName === ""
                        ? ""
                        : productOption.names[0].skuName + ""
                    }}
                  </p>
                  <p>
                    <span
                      @click="selectSku(kt, productOption.names[0])"
                      v-for="(kt, index) in productOption.names[0].values"
                      :key="index"
                      :class="[{ 'selected-item': kt.selected }]"
                      >{{ kt.skuValue }}</span
                    >
                  </p>
                </li>
              </ul>
              <div class="table-container">
                <span>规格</span>
                <div
                  :class="`${
                    tableData.length > 6 && isHidden ? 'table-hiddenbox' : ''
                  }`"
                >
                  <a-table
                    :class="`${
                      tableData.length > 6 && isHidden ? 'table-hidden' : ''
                    }`"
                    :columns="columns"
                    :data-source="tableData"
                    :scroll="columns.length > 7 ? { x: 500 } : {}"
                    :pagination="false"
                    size="small"
                  >
                    <div slot="buyNum" slot-scope="item">
                      <!--:step="buyNumMap[`${item.skuId}`] ? 1 : initBuyNum"-->
                      <!-- :value="buyNumMap[`${item.skuId}`] || item.initPurchase" -->
                      <!-- :max="item.stockNumber" -->
                      <el-input-number
                        v-if="item.groupProductStatus == 1"
                        :min="0"
                        :step="
                          buyNumMap[`${item.skuId}`] ? 1 : item.initPurchase
                        "
                        :value="buyNumMap[`${item.skuId}`]"
                        @change="buyNumChange($event, item)"
                        label="采购数量"
                        size="small"
                        type="number"
                      ></el-input-number>
                      <span style="color: #ccc" v-else>禁止订货</span>
                    </div>
                  </a-table>
                  <div>
                    <div
                      class="table-hidden-btn"
                      v-if="tableData.length > 6"
                      @click="isHidden = !isHidden"
                    >
                      <span
                        :class="`${
                          isHidden ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
                        }`"
                      ></span>
                    </div>
                    <div class="total-info">
                      <span>{{ totalInfo.totalNum }} 件</span>
                      <span>{{ totalInfo.totalPrice }} 元</span>
                      <span>已选清单</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="initBuyNumBox">
              <span>起批量</span>
              <span>{{ productDetailData.initBuyNum }}</span>
            </div>-->
            <div class="initBuyNumBox">
              <span>销量</span>
              <span>{{ productDetailData.number }}</span>
            </div>
            <div class="initBuyNumBox">
              <span>发货</span>
              <span>发货时间以买卖双方约定时间为准</span>
            </div>
            <!-- <div class="productNumber">
            <div class="proDescribeTit">数量：</div>
            <div class="proNumberList">
              <el-input-number v-model="productNumber" :min="0" :max="currentProductData.stockNumber" label="库存"></el-input-number>
              <span>库存<b>{{currentProductData.stockNumber}}</b>件</span>
            </div>
            </div>-->
            <div class="btnBox">
              <div
                class="buyBox"
                v-if="
                  currentProductData.activityType === 0 &&
                  (currentProductData.stockNumber !== 0 ||
                    productDetailData.ifOversold == 1) &&
                  productDetailData.shelveState
                "
              >
                <el-button
                  :disabled="ableToBuy"
                  style="width: 150px; height: 60px; font-size: 18px"
                  type="primary"
                  @click="buyGood"
                  >立即购买</el-button
                >
                <el-button
                  :disabled="ableToBuy"
                  style="width: 150px; height: 60px; font-size: 18px"
                  @click="clickAddCart"
                  >加入采购单</el-button
                >
              </div>
              <div
                class="buyBox"
                v-if="
                  (currentProductData.activityType === 2 &&
                    (currentProductData.stockNumber !== 0 ||
                      productDetailData.ifOversold == 1) &&
                    productDetailData.shelveState) ||
                  (currentProductData.activityType === 3 &&
                    (currentProductData.stockNumber !== 0 ||
                      productDetailData.ifOversold == 1) &&
                    productDetailData.shelveState)
                "
              >
                <!-- <span @click="buyGood">立即购买</span>
                <span @click="clickAddCart" v-if="ifEnable === 1"
                  >加入采购单</span
                > -->
                <el-button
                  :disabled="ableToBuy"
                  style="width: 150px; height: 60px; font-size: 18px"
                  type="primary"
                  @click="buyGood"
                  >立即购买</el-button
                >
                <el-button
                  v-if="ifEnable === 1"
                  :disabled="ableToBuy"
                  style="width: 150px; height: 60px; font-size: 18px"
                  @click="clickAddCart"
                  >加入采购单</el-button
                >
              </div>
              <div
                class="favorites"
                v-if="
                  currentProductData.activityType === 1 &&
                  (currentProductData.stockNumber !== 0 ||
                    productDetailData.ifOversold == 1) &&
                  productDetailData.shelveState
                "
              >
                <!-- <span class="oddBuy" @click="buyGood" v-if="ifEnable===0">单独购买</span> -->
                <!-- <span class="StartGroup" @click="openGroup(1)" v-if="ifEnable===0">我要开团</span> -->
                <!-- <span @click="clickAddCart" v-if="ifEnable===1">加入采购单</span>
                <span @click='buyGood' v-if="ifEnable===1">立即购买</span>-->
                <!-- <span class="StartGroup" @click="buyGood">立即购买</span>
                <span class="oddBuy" @click="clickAddCart">加入采购单</span> -->
                <el-button
                  :disabled="ableToBuy"
                  style="width: 150px; height: 60px; font-size: 18px"
                  type="primary"
                  @click="buyGood"
                  >立即购买</el-button
                >
                <el-button
                  :disabled="ableToBuy"
                  style="width: 150px; height: 60px; font-size: 18px"
                  @click="clickAddCart"
                  >加入采购单</el-button
                >
              </div>
              <div
                class="noStock"
                v-if="
                  currentProductData.stockNumber === 0 &&
                  productDetailData.shelveState &&
                  productDetailData.ifOversold == 0
                "
              >
                <span>已售空</span>
              </div>
              <div class="noStock" v-if="!productDetailData.shelveState">
                <span>已下架</span>
              </div>
            </div>
            <div
              v-if="ableToBuy"
              style="color: #f56c6c; font-size: 16px; margin-top: 20px"
            >
              （{{ enableToBuyText }}）
            </div>
            <div class="initBuyNumBox initBuyNumBox_bottom">
              <span>付款方式</span>
              <span>
                <!-- <p v-if="enablePaymentMode.indexOf(1) != -1 || shopType">
                  <span>
                    <img src="../../assets/images/online_pay.png" alt srcset />
                  </span>
                  <span>在线支付</span>
                </p> -->
                <p v-if="enablePaymentMode.indexOf(3) != -1 || shopType">
                  <span>
                    <img src="../../assets/images/offline_pay.png" alt srcset />
                  </span>
                  <span>转账汇款</span>
                </p>
                <p v-if="enablePaymentMode.indexOf(4) != -1">
                  <span>
                    <img
                      src="../../assets/images/online_credit_pay.png"
                      alt
                      srcset
                    />
                  </span>
                  <span>账期付款</span>
                </p>
                <p  v-if="enablePaymentMode.indexOf(6) != -1">
                  <span>
                    <img src="../../assets/images/jufutong.png" alt srcset />
                  </span>
                  <span>聚富通支付</span>
                </p>
              </span>
            </div>
          </div>
        </a-spin>
        <div class="clearfix"></div>
        <div
          class="pinList"
          v-if="
            currentProductData.activityType === 1 &&
            productDetailData.collageOrders.length &&
            ifEnable === 0
          "
        >
          <div class="fightOrderTit">
            <i class="iconfont">&#xe64c;</i>
            <span>这些人正在拼单</span>
          </div>
          <div class="pinListBox">
            <div
              class="pinItem"
              v-for="item in productDetailData.collageOrders"
              :key="item.collageId"
            >
              <div class="Avatar">
                <img :src="item.headImage" alt />
              </div>
              <div class="pinUserInfo">
                <span class="pUserName">{{ item.name }}</span>
                <span class="notBad">
                  还差
                  <b>{{ item.person }}</b
                  >人拼成
                </span>
                <span class="remainingTime">
                  剩余：
                  <b>{{ item.time | formatTime }}</b>
                </span>
              </div>
              <div
                v-if="!item.lock"
                class="pinBtn"
                @click="goToGroupBuy(item.collageId)"
              >
                和Ta拼
              </div>
              <div v-else class="pinBtn">已结束</div>
            </div>
          </div>
        </div>
      </div>
      <!--      <div class="productDetail">-->
      <!--        <div class="detailTabs">-->
      <!--          <span :class="{compActive: currentComp === 'detailData'}" @click="clickSwitchTab(type = 'detailData')">商品详情</span>-->
      <!--          <span :class="{compActive: currentComp === 'evaluation'}" @click="clickSwitchTab(type = 'evaluation')">商品评论</span>-->
      <!--        </div>-->
      <!--        <div class="detailBox clearfix">-->
      <!--          <div class="detailInfoBox">-->
      <!--            <component :is="currentComp"></component>-->
      <!--          </div>-->
      <!--          <div class="likeProductBox">-->
      <!--            <like-list></like-list>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="tuijianModel" v-if="tuijianItem.length > 0">
        <div class="tuijian">
          <div class="beijing">
            <swiper
              v-if="noProduct"
              class="swiper lunbo"
              :options="swiperOption"
            >
              <swiper-slide
                class="swiper-slide cel"
                v-for="item in tuijianItem"
                :key="item"
              >
                <div
                  class="swiper-content"
                  style="text-align: center; margin-top: 6px"
                >
                  <img
                    :src="item.image"
                    @click="toProductDetail(item)"
                    alt=""
                    srcset
                    style="width: 142px; height: 142px"
                  />
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
              <div class="swiper-button-prev" slot="button-prev">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div class="swiper-button-next" slot="button-next">
                <i class="el-icon-arrow-right"></i>
              </div>
            </swiper>
          </div>
        </div>
      </div>
      <div class="warp">
        <div
          class="bottom"
          style="display: flex; justify-content: space-between"
        >
          <div class="shopBufen">
            <div class="xinxi">
              <div class="topModel" v-if="curShop.shopLogo">
                <div class="shopMingzi">
                  <span class="wenben">{{ curShop.shopName }}</span>
                  <img
                    style="width20px;height:20px;margin-top:-8px;margin-left:5px;"
                    src="../../assets/images/wangwang.png"
                    alt
                  />
                </div>
                <!-- <div class="shopTubiao">
                <img :src="curShop.shopLogo" alt class="tubiao" />
                </div>-->
              </div>
              <div class="topModel" v-else style="overflow: hidden">
                <div class="shopMingzi">
                  <span class="wenben" style="">{{ curShop.shopName }}</span>
                  <img
                    style="width20px;height:20px;margin-top:-8px;margin-left:5px;"
                    src="../../assets/images/wangwang.png"
                    alt
                  />
                </div>
              </div>

              <div
                v-if="adressForm.shopAdress"
                style="
                  display: block;
                  display: flex;
                  justify-content: left;
                  padding: 10px 0 10px 20px;
                "
              >
                <div class="d">
                  <!-- <img
                    style="width: 19px; height: 19px; margin-right: 5px"
                    src="../../assets/images/dingwei.png"
                    alt
                  /> -->
                  <span class="icon-positioning"></span>
                </div>
                <div
                  class="e"
                  style="height: 19px; line-height: 19px; margin-left: 10px"
                >
                  <span
                    style="
                      font-size: 14px;
                      font-family: MicrosoftYaHei;
                      color: #333333;
                      line-height: 19px;
                    "
                    >{{ this.adressForm.shopAdress }}</span
                  >
                </div>
              </div>
              <div class="tiaozhuan">
                <div
                  style="cursor: pointer"
                  class="jindainguang"
                  @click.stop="toStore(collectData.shopId)"
                >
                  <i class="icon-add11"></i>
                  <span
                    style="
                      font-size: 14px;
                      font-family: MicrosoftYaHei;
                      color: #333333;
                      line-height: 50px;
                    "
                    >进店逛逛</span
                  >
                </div>
                <div
                  style="cursor: pointer"
                  class="shoucang"
                  @click="collectShop"
                  title="收藏"
                >
                  <!-- <i class="icon-shoucang1"></i> -->
                  <!-- <span class="text">收藏店铺</span> -->
                  <span
                    :class="`${
                      isCare === 0 ? 'icon-shoucang' : 'icon-shoucang1'
                    }`"
                  ></span>
                  <span
                    v-if="isCare === 0"
                    style="
                      font-size: 14px;
                      font-family: MicrosoftYaHei;
                      color: #333333;
                      line-height: 19px;
                    "
                    >收藏店铺</span
                  >
                  <span
                    v-else
                    style="
                      font-size: 14px;
                      font-family: MicrosoftYaHei;
                      color: #333333;
                      line-height: 19px;
                    "
                    >已收藏店铺</span
                  >
                </div>
              </div>
            </div>
            <div class="classfiy">
              <div class="innerclassify">
                <!-- <div>
                <div
                  v-for="item in shopClassifyList"
                  :key="item.classifyId"
                  :name="item.classifyId.toString()"
                  >{{ item.classifyName }}</div
                >
                </div>-->
              </div>
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>店内分类</span>
                </div>
                <div style="width: 317px; height: 540px">
                  <el-tree
                    :data="categoryItem"
                    :props="defaultProps"
                    @node-click="goStoreClassify"
                  ></el-tree>
                </div>
                <!-- <div
                class="classify-outer"
                :class="`${showClassify ? 'showClassify' : ''}`"
              >
                <cere-classification
                  :componentContent="componentContent[0].componentContent"
                ></cere-classification>
                </div>-->
              </el-card>
            </div>
          </div>
          <div class="productDetail">
            <a-tabs type="card">
              <a-tab-pane key="1" tab="商品详情">
                <div class="detailBox">
                  <div class="detailCont" v-html="productDetailData.text"></div>
                </div>
              </a-tab-pane>
              <a-tab-pane key="2" tab="订购说明">
                <img src="../../assets/images/buy_help.png" alt width="100%" />
              </a-tab-pane>
            </a-tabs>
            <!-- <div class="detailTabs">
          <span
            :class="{ compActive: currentComp === 'detailData' }"
            @click="clickSwitchTab((type = 'detailData'))"
            >商品详情</span
            >-->
            <!-- <span :class="{compActive: currentComp === 'evaluation'}" @click="clickSwitchTab(type = 'evaluation')">商品评论</span>
            <span :class="{compActive: currentComp === 'productAnswer'}" @click="clickSwitchTab(type = 'productAnswer')">商品问答</span>-->
            <!-- <span
            :class="{ compActive: currentComp === 'buyHelp' }"
            @click="clickSwitchTab((type = 'buyHelp'))"
            >订购说明</span
          >
            </div>-->
            <!-- <div class="detailBox clearfix">
          <div class="detailInfoBox">
            <div v-show="currentComp === 'detailData'">
              <div class="detailBox">
                <div class="detailCont" v-html="productDetailData.text"></div>
              </div>
            </div>
            <div v-show="currentComp === 'buyHelp'">
              <img src="../../assets/images/buy_help.png" alt="" width="100%" />
            </div>
          </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="groupBuyDialog"
      width="30%"
      :before-close="groupBuyClose"
    >
      <span>是否跟他拼团？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="groupBuyClose">取 消</el-button>
        <el-button type="primary" @click="openGroup(0)">确 定</el-button>
      </span>
    </el-dialog>  
  </div>
</template>

<script>
import CereClassification from "../../components/canvasShow/cereshop/pc/classification.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import detailData from "./detailData";
import evaluation from "./evaluation";
import likeList from "./likeList";
import store from "../store/index.vue";
import ProductAnswer from "./productAnswer";
import "swiper/dist/css/swiper.css";
import CereHeader from "../../components/canvasShow/cereshop/pc/header";
import api from "../../api";
import { listSearchMixin } from "../../config/mixin";
import { mapGetters, mapMutations } from "vuex";
import Cookie from "js-cookie";
import { Base64 } from "js-base64";
import VueQr from "vue-qr";
// import PicZoom from "vue-piczoom"
export default {
  name: "productDetail",
  mixins: [listSearchMixin],
  components: {
    CereClassification,
    ProductAnswer,
    CereHeader,
    swiper,
    swiperSlide,
    detailData,
    evaluation,
    likeList,
    store,
    VueQr,
    // PicZoom
  },

  inject: ["reload"],
  data() {
    return {
      enablePaymentMode: [],
      shopType: "",
      shopId: null,
      spinning: false,
      currentComp: "detailData",
      swiperTop: null,
      swiperThumbs: null,
      swiperThumbs2: null,
      swiperOptionTop: {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 5,
      },
      shopClassifyList: [],
      swiperOptionThumbs: {
        loop: true,
        slideToClickedSlide: true,
        navigation: {
          nextEl: ".image-button-next",
          prevEl: ".image-button-prev",
        },
        spaceBetween: 10,
        slidesPerView: 5,
        loopedSlides: 5, // looped slides should be the same
        centeredSlides: true,
      },
      swiperOption: {
        slidesPerView: 5, // 每页展示几条数据
        slidesPerGroup: 1, // 每屏滚动几条数据
        autoplay: false, // 是否自动播放
        // loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "",
        },
        observer: true,
        observeParents: true,
      },
      productSizeData: {},
      productColor: {},
      productDetailData: {},
      curShop: {},
      activeName: "Detail",
      productOption: {},
      evaluateParam: {
        productId: "",
        words: [],
      },
      similarProducts: [],
      productPrice: "",
      originalPrice: "",
      // currentProductData: {
      //   productPrice: '',
      //   originalPrice: '',
      //   stockNumber: '',
      //   activityType: ''
      // },
      currentProductData: {},
      productNumber: 1,
      // 商品问答
      productAnswerList: [
        {
          id: 1,
        },
      ],
      priceSpikezNum: 100,
      groupBuyDialog: false,
      setTime: null,
      setTime1: null,
      collageId: null,
      ifEnable: null,
      endTime: "",
      buyNumMap: {},
      initNumMap: {},
      buyPriceMap: {},
      isHidden: true,
      currentPro: JSON.parse(this.$route.query.proData),
      defaultProps: {
        children: "childs",
        label: "classifyName",
        key: "classifyId",
      },
      shopImage: {},
      categoryItem: [],
      adressForm: {
        shopAdress: "",
      },
      productId: "",
      status: 1,
      stockNumber: "",
      tuijianItem: [],
      searchFrom: {
        search: "",
      },
      adressForm: {
        shopAdress: "",
      },
      showClassify2: false,
      chargePersonPhone: "400-082-3633",
      type: "",
      volume: "",
      page: 1,
      ifNew: "",
      imgData: [],
      formData: [],
      noProduct: false,
      isCare: 0,
      ableToBuy: false,
      enableToBuyText: "",
      imgurl: "",
      imagesList: [],
      qrcode: "",
      logoSrc: "",
      appSrc: "",
      shopCode: false,
      showMenu: false,
      showMenu2: false,
      menuChildren: {},
      subMenu: false,
      flagItem: "",
    };
  },
  filters: {
    formatHours: function (value) {
      let hours = Math.floor(value / (1000 * 60 * 60));
      if (hours < 10) {
        return "0" + hours;
      } else {
        return hours;
      }
    },
    formatMinutes: function (value) {
      let minutes = Math.floor((value % (1000 * 60 * 60)) / (1000 * 60));
      if (minutes < 10) {
        return "0" + minutes;
      } else {
        return minutes;
      }
    },
    formatSeconds: function (value) {
      let seconds = Math.round((value % (1000 * 60)) / 1000);
      if (seconds < 10) {
        return "0" + seconds;
      } else {
        return seconds;
      }
    },
    formatTime: function (value) {
      let hours = Math.floor(value / (1000 * 60 * 60));
      let minutes = Math.floor((value % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.round((value % (1000 * 60)) / 1000);
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return hours + ":" + minutes + ":" + seconds;
    },
  },
  computed: {
    ...mapGetters(["collectData", "classify", "componentContent"]),

    // 起够数量
    initBuyNum() {
      return this.productDetailData.initBuyNum;
    },
    currentProductPrice() {
      let arr = [];
      if (this.productOption.map) {
        for (let key in this.productOption.map) {
          arr.push(this.productOption.map[key].price);
        }
        let max = Math.max(...arr);
        let min = Math.min(...arr);
        return { min, max };
        // `${min === max ? `¥${min}` : `¥${min}-¥${max}`}`;
      }
      return "";
    },
    namesMap() {
      if (this.productOption.names) {
        let obj = {};
        this.productOption.names.map((item) => {
          obj[item.nameCode] = item.skuName;
        });
        return obj;
      } else {
        return null;
      }
    },
    valuesMap() {
      if (this.productOption.names) {
        let arr = [];
        let obj = {};
        this.productOption.names.map((item) => {
          arr = arr.concat(item.values);
        });
        arr.map((item) => {
          obj[item.valueCode] = item.skuValue;
        });
        return obj;
      } else {
        return null;
      }
    },
    columns() {
      if (this.namesMap) {
        let arr = [];
        for (let key in this.namesMap) {
          let obj = {};
          obj.title = this.namesMap[key];
          obj.dataIndex = key;
          obj.key = key;
          obj.align = "center";
          arr.push(obj);
        }
        arr = arr.concat([
          {
            title: "价格",
            key: "price",
            dataIndex: "price",
            align: "center",
          },
          {
            title: "库存",
            key: "stockNumber",
            dataIndex: "stockNumber",
            align: "center",
            customRender: (val) => {
              return this.productDetailData.ifOversold == 1 ? "允许超卖" : val;
            },
          },
          {
            title: "起购数",
            key: "initPurchase",
            dataIndex: "initPurchase",
            align: "center",
          },
          {
            title: "采购数量",
            key: "buyNum",
            fixed: "right",
            width: 200,
            align: "center",
            scopedSlots: { customRender: "buyNum" },
          },
        ]);
        return arr;
      } else {
        return [];
      }
    },
    tableData() {
      if (this.productOption.names) {
        let arr = this.productOption.names[0].values;
        let curSelect = arr.filter((item) => item.selected)[0] || null;
        let curSelectValue = curSelect ? curSelect.valueCode : null;
        let maps = this.productOption.map;
        let tableData = [];
        for (let key in maps) {
          if (key.split(",")[0] === curSelectValue) {
            let keys = key.split(",");
            let obj = {};
            keys.map((item) => {
              obj[item.split("_value_")[0]] = this.valuesMap[item];
            });
            tableData.push({
              ...maps[key],
              ...obj,
              buyNum: 0,
            });
          }
        }
        return tableData;
      } else {
        return [];
      }
    },
    totalInfo() {
      let obj = this.buyNumMap;
      let totalNum = 0;
      let totalPrice = 0;
      for (let key in obj) {
        totalNum += obj[key];
      }
      obj = this.buyPriceMap;
      for (let key in obj) {
        totalPrice += obj[key];
      }
      totalPrice = Number(totalPrice).toFixed(2);
      return {
        totalNum,
        totalPrice,
      };
    },
  },
  created() {
    if (this.$route.query.proData) {
      this.getShopIndex();
      this.getShopClassify();
      this.getProductInfo();
      this.getShopInfo();
    }
  },
  mounted() {
    this.getNew();
    let _this = this;
    this.$nextTick(() => {
      setTimeout(() => {
        _this.swiperTop = _this.$refs.swiperTop.swiper;
        _this.swiperThumbs = _this.$refs.swiperThumbs.swiper;
        _this.swiperTop.controller.control = _this.swiperThumbs;
        _this.swiperThumbs.controller.control = _this.swiperTop;
      }, 1000);
    });
    // debugger
    // this.getStatusProduct();
    this.shopId = parseInt(this.$route.query.shopId);
    // this.getShopProducts();
    this.getClassifyInfo();
    var video = document.getElementsByTagName("video");
    console.log(video); //通过打印拿到所有的属性和方法
    video[0] && (video[0]["disablePictureInPicture"] = true); //disablePictureInPicture的属性改为true
  },
  destroyed() {
    clearInterval(this.setTime);
    clearInterval(this.setTime1);
  },
  methods: {
    getAllProduct() {
      if (this.searchFrom.search) {
        this.setSearchObj({
          search: this.searchFrom.search,
        });
        if (this.$route.name !== "search") {
          this.$router.push({
            path: "/search",
            query: {
              search: this.searchFrom.search,
            },
          });
        }
        // let self = this;
        // self.loading = true;
        // let params = {
        //   url:
        //     api.getSearchProducts +
        //     `?search=${this.searchFrom.search}&type=${self.type}&maxMoney=${self.maxMoney}&minMoney=${self.minMoney}&volume=${self.volume}&page=${self.page}&pageSize=12`,
        //   method: "GET",
        //   data: {},
        // };
        // self.sendReq(params, (res) => {
        //   if (res.code === "200") {
        //     self.productList = res.data.list;
        //     self.total = res.data.total;
        //     // self.loading = false;
        //     // self.network = false;
        //     if (res.data.list.length < 1) {
        //       self.noProduct = true;
        //     } else {
        //       self.noProduct = false;
        //     }
        //   } else {
        //     self.$message({
        //       message: res.message,
        //       type: "warning",
        //     });
        //     self.network = true;
        //   }
        // });
      } else {
        this.$message({
          message: "请输入搜索内容",
          type: "warning",
        });
      }
    },
    getChildren(item) {
      this.showMenu2 = true;
      // this.subMenu = true;
      this.menuChildren = item;

      // console.log(this.menuChildren);
    },
    clianChildren(item) {
      this.showMenu2 = false;
      this.flagItem = item.classifyId;
      // this.subMenu = false;
      // this.menuChildren = {};
    },
    getInfoProduct() {
      if (this.collectData.shopId) {
        if (this.searchFrom.search) {
          +this.$router.push({
            path: "/store?shopId=" + `${this.collectData.shopId}`,
            query: {
              search: this.searchFrom.search,
              activeName: "shopClassifyList",
            },
          });
        } else {
          this.$message({
            message: "请输入搜索内容",
            type: "warning",
          });
        }
      }
    },
    handleNodeClick() {
      let data = {
        productId: this.categoryItem.classifyId,
        shopId: this.collectData.shopId,
      };
      this.$router.push({
        path: "/store?this.currentPro.shopId",
        query: {
          proData: JSON.stringify(data),
        },
      });
    },
    //商家推荐点击进入商品详情
    toProductDetail(item) {
      let data = {
        productId: item.productId,
        skuId: item.skuId,
        shopId: item.shopId,
      };
      this.$router.push({
        path: "/productDetail",
        query: {
          proData: JSON.stringify(data),
        },
      });
      this.reload();
    },
    // 获取店铺首页
    getShopInfo() {
      if (this.collectData.shopId) {
        let params = {
          url: api.getShopIndex + `?shopId=${this.collectData.shopId}`,
          method: "GET",
        };
        this.sendReq(params, (res) => {
          if (res.code === "200") {
            this.formData = res.data;
            this.isCare = res.data.ifCollect;
            this.qrcode = res.data.shopQrCode;
            Base64.decode(this.qrcode);
            console.log(this.qrcode);
            console.log(Base64.decode(this.qrcode));
            // this.appSrc = Base64.decode(this.qrcode);
            this.appSrc = this.qrcode;
            if (res.data.shopLogo) {
              this.logoSrc = res.data.shopLogo;
            } else {
              this.logoSrc =
                "https://static.xhngyl.com/xhngyl-platform-gy/dev/logo/2021-11-12/1d635fcd30cc44e2832f6e1a91d689d2-logo.png";
            }
            // this.shopName = res.data.shopName;
            // this.shopIntroduce = res.data.shopIntroduce;
          } else {
            // this.$message.warning(res.message);
          }
        });
      }
    },
    getNew() {
      if(this.collectData.shopId){
        let self = this;
      self.status = 1;
      let _url =
        api.getShopProducts +
        `?shopId=${this.collectData.shopId}&ifNew=${self.ifNew}&status=${self.status}&page=${self.page}&pageSize=20&type=${self.type}&volume=${self.volume}`;
      // if (self.activeName !== "all") {
      //   _url += `&classifyId=${self.activeName}`;
      // }
      let params = {
        url: _url,
        method: "GET",
        data: {},
      };
      this.tuijianItem = [];
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          //获取推荐商品列表图片
          // this.productList = res.data.page.list;
          let imgUrl = res.data.page.list;
          this.total = res.data.page.total;
          console.log(imgUrl);
          for (let i = 0; i < imgUrl.length; i++) {
            if (imgUrl[i].productStatus == 1) {
              this.tuijianItem.push(imgUrl[i]);
            }
          }
          if (this.tuijianItem.length > 0) {
            this.noProduct = true;
          } else {
            this.noProduct = false;
          }
          // if (this.tuijianItem.length == 0) {
          //   this.noImg = false;
          // } else {
          //   this.noImg = true;
          // }
          // if (res.data.page.list.length < 1) {
          //   this.noProduct = true;
          // } else {
          //   this.noProduct = false;
          // }
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
      }
      
    },
    getShopProducts() {
      let self = this;
      let _url =
        api.getShopProducts +
        `?shopId=${this.collectData.shopId}&ifNew=${self.ifNew}&status=${self.status}&page=${self.page}&pageSize=9999&type=${self.type}&volume=${self.volume}`;
      // if (self.activeName !== "all") {
      //   _url += `&classifyId=${self.activeName}`;
      // }
      let params = {
        url: _url,
        method: "GET",
        data: {},
      };
      // this.imgData = [];
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          //获取推荐商品列表图片
          this.productList = res.data.page.list;
          // let imgUrl = res.data.page.list;
          // console.log(imgUrl);
          // for (let i = 0; i < imgUrl.length; i++) {
          //   if (imgUrl[i].productStatus == 1) {
          //     this.imgData.push(imgUrl[i]);
          //   }
          // }
          // if (this.imgData.length == 0) {
          //   this.noImg = false;
          // } else {
          //   this.noImg = true;
          // }
          if (res.data.page.list.length < 1) {
            this.noProduct = true;
          } else {
            this.noProduct = false;
          }
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    gotoIndex() {
      this.$router.push({ path: "/" });
    },
    // 获取店铺首页
    getShopIndex() {
      let params = {
        url: api.getShopIndex + `?shopId=${this.shopId}`,
        method: "GET",
      };
      this.sendReq(params, (res) => {
        if (res.code === "200") {
          let data = {
            ifCollect: res.data.ifCollect,
            collectId: res.data.collectId,
            shopAdress: res.data.shopAdress,
            shopName: res.data.shopName,
            shopId: res.data.shopId,
            classifyNumber: res.data.classifyNumber,
            number: res.data.number,
            shopLogo: res.data.shopLogo,
          };
          this.adressForm.shopAdress = res.data.shopAdress;
          this.shopName = res.data.shopName;
          this.shopLogo = res.data.shopLogo;
          this.setCollectData(data);
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    // //获取推荐商品
    // getStatusProduct() {
    //   let self = this;
    //   let params = {
    //     url:
    //       api.getShops +
    //       `?shopId=${this.collectData.shopId}&status=1&page=1&pageSize=999`,
    //     method: "GET",
    //     data: {},
    //   };
    //   self.sendReq(params, (res) => {
    //     if (res.code === "200") {
    //       console.log(res.data.list);
    //     } else {
    //       self.$message({
    //         message: res.message,
    //         type: "warning",
    //       });
    //     }
    //   });
    // },
    //获取分类
    getClassifyInfo() {
      let self = this;
      if (this.currentPro.shopId) {
        let _url = api.getClassify + `?shopId=${this.currentPro.shopId}`;
        // if (self.activeName !== "all") {
        //   _url += `&classifyId=${self.activeName}`;
        // }
        let params = {
          url: _url,
          method: "GET",
          data: {},
        };
        this.sendReq(params, (res) => {
          if (res.code === "200") {
            // console.log(res.data);

            self.shopClassifyList = res.data;
          } else {
            self.$message({
              message: res.message,
              type: "warning",
            });
          }
        });
      }
    },
    // 跳转到店铺
    toStore(id) {
      this.$router.push({
        path: "/store",
        query: { shopId: id },
      });
    },
    ...mapMutations({
      setCartNumber: "SET_CARTNUMBER",
      setShoppingCart: "SET_SHOPPINGCART",
      setCollectData: "SET_COLLECTDATA",
      setSearchObj: "SET_SEARCHOBJ",
    }),
    collectShop() {
      if (this.collectData.ifCollect === 0) {
        let params = {
          url: api.collect,
          method: "POST",
          data: {
            shopId: this.collectData.shopId,
          },
        };
        this.sendReq(params, (res) => {
          if (res.code === "200") {
            let data = {
              shopName: this.collectData.shopName,
              shopAdress: this.collectData.shopAdress,
              collectId: this.collectData.collectId,
              ifCollect: 1,
              classifyNumber: res.data.classifyNumber,
              number: res.data.number,
              shopLogo: res.data.shopLogo,
            };
            this.setCollectData(data);
            this.$message.success("收藏成功");
            this.isCare = 1;
          }
        });
      } else {
        let params = {
          url: api.unfavorite,
          method: "PUT",
          data: {
            ids: [this.collectData.collectId],
          },
        };
        this.sendReq(params, (res) => {
          if (res.code === "200") {
            let data = {
              shopName: this.collectData.shopName,
              shopAdress: this.collectData.shopAdress,
              collectId: this.collectData.collectId,
              ifCollect: 0,
              classifyNumber: res.data.classifyNumber,
              number: res.data.number,
              shopLogo: res.data.shopLogo,
            };
            this.setCollectData(data);
            this.$message.success("取消成功");
            this.isCare = 0;
          }
        });
      }
    },
    buyNumChange(val, item) {
      if (val) {
        val = Math.floor(val);
      }
      this.stockNumber = item.stockNumber;
      // if (val > item.stockNumber && this.productDetailData.ifOversold == 1) {
      //   this.$message.warning("库存不足！");
      //   // val =  item.stockNumber;
      // }
      if (typeof val === "undefined") {
        val = 0;
        console.log(val);
        val = Number(val);

        this.buyNumMap = {
          ...this.buyNumMap,
          [`${item.skuId}`]: Number(val),
        };
      }

      this.initNumMap = {
        ...this.initNumMap,
        [`${item.skuId}`]: Number(item.initPurchase),
      };

      this.buyNumMap = {
        ...this.buyNumMap,
        [`${item.skuId}`]: Number(val),
      };
      console.log(this.buyNumMap);
      console.log(this.initNumMap);
      this.buyPriceMap = {
        ...this.buyPriceMap,
        [`${item.skuId}`]: Number(val) * item.price,
      };
    },
    // 活动倒计时
    countDown() {
      clearInterval(this.setTime);
      this.setTime = setInterval(() => {
        if (this.endTime > 1000) {
          this.endTime -= 1000;
        } else {
          this.endTime = 0;
          clearInterval(this.setTime);
          alert("活动已结束");
          window.location.reload();
        }
      }, 1000);
    },
    // 拼团倒计时
    countDown1() {
      clearInterval(this.setTime1);
      this.setTime1 = setInterval(() => {
        this.productDetailData.collageOrders.map((item) => {
          if (item.time > 1000) {
            item.time -= 1000;
          } else {
            this.$set(item, "lock", true);
            item.time = 0;
          }
        });
      }, 1000);
    },
    // 获取店铺信息
    getShopIndex() {
      let params = {
        url: api.getShopIndex + `?shopId=${this.currentPro.shopId}`,
        method: "GET",
      };
      this.sendReq(params, (res) => {
        if (res.code === "200") {
          let data = {
            ifCollect: res.data.ifCollect,
            collectId: res.data.collectId,
            shopAdress: res.data.shopAdress,
            shopName: res.data.shopName,
            shopId: res.data.shopId,
            classifyNumber: res.data.classifyNumber,
            number: res.data.number,
            shopLogo: res.data.shopLogo,
          };
          this.adressForm.shopAdress = res.data.shopAdress;
          this.curShop = res.data;
          this.setCollectData(data);
        }
      });
    },
    //店内分类点击调转
    goStoreClassify(event) {
      console.log(event.classifyId);
      // if (classifyId) {
      //   query = {
      //     ...query,
      //     classifyId,
      //   };
      // }
      this.$router.push({
        path: "/store?shopId=" + `${this.currentPro.shopId}`,
        query: {
          classifyId: event.classifyId,
          activeName: "shopClassifyList",
        },
      });
    },
    //从商品详情分类跳转店铺商品列表
    goStoreClassifyDetail(id) {
      console.log(id);
      this.$router.push({
        path: "/store?shopId=" + `${this.currentPro.shopId}`,
        query: {
          classifyId: id,
          activeName: "shopClassifyList",
          shopClassifyList: this.shopClassifyList,
        },
      });
    },
    // 跳转去店铺页
    goStore(classify) {
      if(sessionStorage.getItem("curentPage4")){
        sessionStorage.removeItem("curentPage4");
      }
      let query = {
        shopId: this.currentPro.shopId,
      };
      if (classify) {
        query = {
          ...query,
          classify,
        };
      }
      this.$router.push({
        path: "/store",
        query,
      });
    },
    // 获取商品详情
    getProductInfo() {
      const rLoading = this.openLoading();
      // console.log(this.currentPro, 'productData')
      let self = this;
      let params = {
        url: api.getProDetail,
        method: "GET",
        payload: {
          shopId: self.currentPro.shopId,
          productId: self.currentPro.productId,
          skuId: self.currentPro.skuId,
          terminal: "3",
          system: "3",
          city: "",
        },
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          if (res.data.enableToBuy == 0) {
            self.ableToBuy = true;
          }
          self.shopType = res.data.shopType;
          self.enablePaymentMode = res.data.enablePaymentMode;
          self.enableToBuyText = res.data.enableToBuyText;
          self.productDetailData = res.data;
          self.evaluateParam.productId = self.productDetailData.productId;
          self.evaluateParam.words = self.productDetailData.words;
          self.similarProducts = self.productDetailData.similarProducts;
          self.getProOption();
          if (self.productDetailData.collageOrders.length) {
            self.countDown1();
          }
          if (res.data.images && res.data.images.length < 5) {
            self.swiperOptionThumbs.loop = false;
            self.swiperOptionThumbs.centeredSlides = true;
            self.swiperOptionTop.loop = false;
            setTimeout(() => {
              self.$forceUpdate();
            }, 1000);
          }
          // this.tuijianItem = res.data.shopProducts.page.list;
          // if (this.tuijianItem.length > 0) {
          //   this.noProduct = true;
          // } else {
          //   this.noProduct = false;
          // }
          window.scrollTo(0, 0);
          rLoading.close();
        } else {
          self.$message(res.message);
        }
      });
    },
    // 获取店铺分类
    getShopClassify() {
      let self = this;
      let params = {
        url: api.getShopClassify + `?shopId=${this.currentPro.shopId}`,
        method: "GET",
        data: {},
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.categoryItem = res.data;
          self.shopClassifyList = res.data.filter(
            (item) => JSON.stringify(item) !== "{}"
          );
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    reloadDetail() {
      this.$router.go(0);
      // this.reload()
    },
    // 获取商品规格信息
    getProOption() {
      let self = this;
      let params = {
        url: api.getProOption,
        method: "GET",
        payload: {
          shopId: self.currentPro.shopId,
          productId: self.currentPro.productId,
        },
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.productOption = res.data;
          self.ifEnable = res.data.skuTool.ifEnable;
          let nowTime = Date.now();
          self.endTime = new Date(res.data.skuTool.endTime).getTime() - nowTime;
          console.log(res.data.names.length,"res.data.names.length")
          if(res.data.map["单款项"]){
            res.data.names[0].values[0].valueCode = "单款项"
            res.data.names[0].skuName = "规格"
            res.data.names[0].nameCode = "单款项"
          }
          if (res.data.names.length !== 0) {
            let sku = [];
            for (var i in res.data.map) {
              if (res.data.map[i].skuId === self.currentPro.skuId) {
                self.currentProductData.stockNumber =
                  res.data.map[i].stockNumber;
                self.currentProductData.price = res.data.map[i].price;
                self.currentProductData.originalPrice =
                  res.data.map[i].originalPrice;
                self.currentProductData.skuId = res.data.map[i].skuId;
                self.currentProductData.activityType =
                  res.data.map[i].activityType;
                sku = i.split(",");
              }
              //这里请求到数据后 直接触发规格选择事件 因为有的规格有起批量
              if (res.data.map[i].initPurchase) {
                // self.buyNumChange(res.data.map[i].initPurchase,res.data.map[i])
                self.buyNumChange(0, res.data.map[i]);
              }
            }
            console.log(sku,"sku")
            let temp = true;
            for (var j in res.data.map) {
              if (res.data.map[j].skuId === self.currentPro.skuId) {
                temp = false;
              }
            }
            if (temp) {
              self.currentProductData.stockNumber =
                res.data.map[["attr_code_0_value_0"]].stockNumber;
              self.currentProductData.price =
                res.data.map[["attr_code_0_value_0"]].price;
              self.currentProductData.originalPrice =
                res.data.map[["attr_code_0_value_0"]].originalPrice;
              self.currentProductData.skuId =
                res.data.map[["attr_code_0_value_0"]].skuId;
              self.currentProductData.activityType =
                res.data.map[["attr_code_0_value_0"]].activityType;
              sku = ["attr_code_0_value_0"];
            }
            sku.map((l) => {
              res.data.names.map((j) => {
                // j.values[0].selected = true
                j.values.map((k) => {
                  if (k.valueCode === l) {
                    self.$set(k, "selected", true);
                  }
                });
              });
            });
          } else {
            self.currentProductData.stockNumber =
              res.data.map["单款项"].stockNumber;
            self.currentProductData.price = res.data.map["单款项"].price;
            self.currentProductData.originalPrice =
              res.data.map["单款项"].originalPrice;
            self.currentProductData.skuId = res.data.map["单款项"].skuId;
            self.currentProductData.activityType =
              res.data.map["单款项"].activityType;
          }
          // self.currentProductData.stockNumber = self.productOption.stockNumber
          // self.currentProductData.price = self.productOption.price
          // self.currentProductData.originalPrice = self.productOption.originalPrice
          // self.currentProductData.activityType = self.productDetailData.activityType
          self.productSizeData = res.data.names[0];
          self.productColor = res.data.names[1];
          if (self.endTime > 1000) {
            this.countDown();
          }
          // console.log(res.data.names, 'names')
        } else {
          self.$message(res.message);
        }
      });
    },
    // 加入采购单
    clickAddCart() {
      console.log(this.productDetailData.markTools);
      console.log(this.totalInfo);

      // console.log(this.productDetailData)
      if (this.totalInfo.totalNum === 0) {
        this.$message.warning(`您好,您还没有选择商品`);
        return;
      }

      let arr = [];
      console.log(this.buyNumMap);
      for (let key in this.buyNumMap) {
        if (this.buyNumMap[key] !== 0) {
          arr.push({
            number: this.buyNumMap[key],
            skuId: key,
          });
        }
      }
      if (arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (this.initNumMap[arr[i].skuId] > arr[i].number) {
            arr.splice(i, 1);
          }
        }
      }

      // let numData = []
      // for(let i in this.initNumMap){

      //   if(this.buyNumMap[i]>0&&this.buyNumMap[i]>=this.initNumMap[i] ){
      //     numData.push({
      //       number: this.buyNumMap[i],
      //       skuId: i,
      //     })
      //     for(let j = 0;j<=numData.length;j++){
      //       if(this.initNumMap[numData[j].skuId]>numData[j].number && this.initNumMap[numData[j].skuId]!=0 ){
      //         numData.remove(j)
      //       }
      //     }
      //   }

      // }

      console.log(arr);
      if (arr.length == 0) {
        this.$message.warning(`您好,您选择的商品中采购数量不足采购数`);
        return;
      }
      // if (this.productDetailData.initBuyNum) {
      //   if (this.totalInfo.totalNum < this.productDetailData.initBuyNum) {
      //     this.$message.warning(
      //       `您好,该商品限制最低起批量为${this.productDetailData.initBuyNum}`
      //     );
      //     return;
      //   }
      // }
      // if (this.currentProductData.stockNumber > 0) {
      let self = this;
      // console.log(self.productOption, 'productOption')
      // if (self.productOption.names.length === 0) {
      //   var skuId = self.productOption.names[0].skuId
      // }
      // let arr = [];
      // console.log(this.buyNumMap);
      // for (let key in this.buyNumMap) {
      //   if (this.buyNumMap[key] !== 0) {
      //     arr.push({
      //       number: this.buyNumMap[key],
      //       skuId: key,
      //     });
      //   }
      // }
      // console.log(arr);
      //这里改为批量添加购物车
      this.spinning = true;
      let params = {
        url: api.addCartGroup,
        method: "POST",
        data: {
          carts: arr,
        },
      };
      self.sendReq(params, (res) => {
        this.spinning = false;
        if (res.code === "200") {
          self.$message.success("添加成功");
          self.getTrolleyList();
        } else {
          self.$message.warning(res.message);
        }
      });
      // } else {
      //   this.$message.warning('商品库存不足')
      // }
    },
    // 采购单列表
    async getTrolleyList() {
      const vm = this;
      const params = {
        url: api.getTrolleyList,
        method: "GET",
      };
      vm.sendReq(params, (res) => {
        const d = res.data;
        let cartNumber = 0;
        if (d.length) {
          this.setShoppingCart(d);
          d.forEach((j) => {
            cartNumber = cartNumber + j.skus.length;
          });
        }
        this.setCartNumber(cartNumber);
      });
    },
    clickSwitchTab(type) {
      this.currentComp = type;
    },
    handleClick(event) {
      this.$router.push({
        path: "/store?shopId=" + `${this.currentPro.shopId}`,
        query: {
          activeName: this.activeName,
        },
      });
    },
    handleClickMenu(item) {
      this.$router.push({
        path: "/store?shopId=" + `${this.currentPro.shopId}`,
        query: {
          activeName: this.activeName,
        },
      });
    },
    // 购买
    buyGood() {
      // if (this.currentProductData.stockNumber > 0) {
      if (!Cookie.get("token")) {
        this.$message.warning("请先登录");
        this.$store.commit("resetVuex");
        this.$router.push({ path: "/login" });
      } else {
        // if (this.productOption.names.length === 0) {
        //   var skuId = this.productOption.names[0].skuId
        // }
        //立即购买会生成订单,在这之前需要判断是否有企业认证
        if (this.totalInfo.totalNum === 0) {
          this.$message.warning(`您好,您还没有选择商品`);
          return;
        }

        let arr = [];
        for (let key in this.buyNumMap) {
          if (this.buyNumMap[key] !== 0) {
            arr.push({
              skuId: key,
              number: this.buyNumMap[key],
            });
          }
        }
        if (arr.length > 0) {
          for (let i = 0; i < arr.length; i++) {
            if (this.initNumMap[arr[i].skuId] > arr[i].number) {
              arr.splice(i, 1);
            }
            if (
              this.stockNumber < arr[i].number &&
              this.productDetailData.ifOversold != 1
            ) {
              this.$message.warning("商品库存不足");
              return;
            }
          }
        }
        if (arr.length == 0) {
          this.$message.warning(`您好,您选择的商品中采购数量不足采购数`);
          return;
        }
        //   if (this.totalInfo.totalNum > this.currentProductData) {
        //   this.$message.warning("购买数量不能大于库存数！");
        //   return;
        //   // val =  item.stockNumber;
        // }
        this.spinning = true;
        let params = {
          url: api.enterprisePass,
          method: "POST",
          data: {},
        };
        this.sendReq(params, (res) => {
          this.spinning = false;
          if (res.code === "200") {
            // if (this.productDetailData.initBuyNum) {
            //   if (this.totalInfo.totalNum < this.productDetailData.initBuyNum) {
            //     this.$message.warning(
            //       `您好,该商品限制最低起批量为${this.productDetailData.initBuyNum}`
            //     );
            //     return;
            //   }
            // }

            const o = this.productOption;
            let shopsData = [
              {
                shopId: o.shopId,
                skus: arr,
                // [
                //   {
                //     // skuId: skuId || this.getSkuId(),
                //     skuId: this.currentProductData.skuId,
                //     number: this.productNumber
                //   }
                // ]
              },
            ];
            if (
              this.currentProductData.activityType === 2 &&
              this.ifEnable === 0
            ) {
              shopsData[0].shopSeckillId =
                this.productOption.skuTool.shopSeckillId;
            } else if (
              this.currentProductData.activityType === 3 &&
              this.ifEnable === 0
            ) {
              shopsData[0].shopDiscountId =
                this.productOption.skuTool.shopDiscountId;
            }
            let paramsType = null;
            if (
              this.currentProductData.activityType === 0 ||
              (this.currentProductData.activityType !== 0 &&
                this.ifEnable === 1)
            ) {
              paramsType = 0;
            } else {
              paramsType = this.currentProductData.activityType;
            }
            this.$router.push({
              path: "/placeOrder",
              query: {
                type: 1,
                ifWork:
                  this.currentProductData.activityType === 1 &&
                  this.ifEnable === 0
                    ? 1
                    : 0,
                shops: JSON.stringify(shopsData),
                activityType: paramsType,
              },
            });
          } else {
            this.$message.warning(`${res.message},将为您跳转到认证页面...`);
            setTimeout(() => {
              this.$router.push({ path: "/companyCertificate" });
            }, 2000);
          }
        });
      }
    },
    // 拼团
    openGroup(x) {
      if (this.currentProductData.stockNumber > 0) {
        if (!Cookie.get("token")) {
          this.$message.warning("请先登录");
          this.$store.commit("resetVuex");
          this.$router.push({ path: "/login" });
        } else {
          // if (this.productOption.names.length === 0) {
          //   var skuId = this.productOption.names[0].skuId
          // }
          const o = this.productOption;
          let worksData = {
            shopId: o.shopId,
            number: this.productNumber,
            // skuId: skuId || this.getSkuId(),
            skuId: this.currentProductData.skuId,
            productId: this.productDetailData.productId,
            type: x ? 1 : 2,
          };
          if (x) {
            worksData.shopGroupWorkId =
              this.productOption.skuTool.shopGroupWorkId;
          } else {
            worksData.shopGroupWorkId =
              this.productOption.skuTool.shopGroupWorkId;
            worksData.collageId = this.collageId;
          }
          this.$router.push({
            path: "/placeOrder",
            query: {
              works: JSON.stringify(worksData),
              activityType: this.currentProductData.activityType,
            },
          });
        }
      } else {
        this.$message.warning("商品库存不足");
      }
    },
    // 选择规格sku
    selectSku(o, list) {
      const temp = this.productOption.names;
      this.productNumber = 1;
      if (list.values.length > 1) {
        temp.forEach((j) => {
          if (j.nameCode === list.nameCode) {
            j.values.forEach((k) => {
              this.$set(k, "selected", k.valueCode === o.valueCode);
            });
          }
        });
      }
      let selectOption = [];
      temp.forEach((j) => {
        j.values.forEach((k) => {
          if (k.selected) {
            selectOption.push(k.valueCode);
          }
        });
      });
      let select = selectOption.toString();
      for (let key in this.productOption.map) {
        if (key === select) {
          this.currentProductData = this.productOption.map[key];
        }
      }
    },
    // 获取skuId
    // getSkuId () {
    //   const temp = this.productOption
    //   let id = ''
    //   temp.names.forEach(j => {
    //     j.values.forEach(k => {
    //       if (k.selected) id = ((id && `${id},`) || '') + k.valueCode
    //     })
    //   })
    //   return temp.map[id].skuId
    // },
    // 领取平台优惠券
    getThisCoupon(item, index) {
      if (item.state === 3) {
        let self = this;
        let params = {
          url: api.takeCoupon,
          method: "POST",
          data: {
            couponId: item.couponId,
          },
        };
        self.sendReq(params, (res) => {
          if (res.code === "200") {
            self.$message.success("领取成功");
            item.state = 0;
          } else {
            self.$message(res.message);
          }
        });
      }
    },
    // 领取店铺优惠券
    getThisCoupon1(item, index) {
      if (item.state === 3) {
        let self = this;
        let params = {
          url: api.takeCoupon,
          method: "POST",
          data: {
            shopCouponId: item.shopCouponId,
          },
        };
        self.sendReq(params, (res) => {
          if (res.code === "200") {
            self.$message.success("领取成功");
            item.state = 0;
          } else {
            self.$message(res.message);
          }
        });
      }
    },
    // 拼团确认
    goToGroupBuy(id) {
      this.collageId = id;
      this.groupBuyDialog = true;
    },
    // 取消拼团
    groupBuyClose() {
      this.collageId = null;
      this.groupBuyDialog = false;
    },
    // 轮播图
    thumbsClick(index) {
      // this.swiperThumbs.slideTo(index, 300, false);
      // this.swiperTop.slideTo(index, 300, false);
    },
    // 收藏
    collect() {
      if (this.productDetailData.ifCollect === 0) {
        let params = {
          url: api.collect,
          method: "POST",
          data: {
            productId: this.productDetailData.productId,
          },
        };
        this.sendReq(params, (res) => {
          if (res.code === "200") {
            this.$message.success("收藏成功");
            this.productDetailData.ifCollect = 1;
          }
        });
      } else {
        let params = {
          url: api.unfavorite,
          method: "PUT",
          data: {
            ids: [this.productDetailData.collectId],
          },
        };
        this.sendReq(params, (res) => {
          if (res.code === "200") {
            this.$message.success("取消收藏");
            this.productDetailData.ifCollect = 0;
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ShopMenu {
  position: absolute;
  top: 45px;
  left: 0;
  z-index: 999999;
}
.selectMenu {
  transform: rotate(180deg);
}
.selectMenuSub {
  color: #ff7b0b;
}
.el-icon-caret-bottom {
  transition: all linear 0.3s;
}
.menuall {
  display: flex;
  justify-content: left;

  // height: 300px;
  background-color: #fff;
  margin-top: 4px;
  padding: 5px 0;

  border-radius: 4px;
  box-shadow: 0px 7px 11px 4px rgba(231, 234, 235, 0.5);
}
.menuItem {
  width: 150px;
  margin: 5px 0;
  text-align: left;
  padding-left: 30px;
  font-size: 16px;
  color: #000000;

  .selectMenu2 {
    transition: all linear 0.2s;
  }
  &:hover {
    color: #f77b0b;
    .selectMenu2 {
      transform: rotate(180deg);
      transition: all linear 0.2s;
    }
  }
}
.hoverBox {
  width: auto;
  // padding: 6px 25px;
  height: 100%;
  // left: 100%;
  // top: 0;
  z-index: 3;
  // display: none;
  background-color: #fff;
  color: #333;
  // box-shadow: -3px 9px 15px 0px rgba(0, 0, 0, 0.5);
  // border: 2px solid $mainColor;

  .dl {
    margin-bottom: 5px;
    display: flex;

    .dt {
      width: 100px;
      margin-left: 30px;
      height: 50px;
      display: flex;
      // padding-top: 5px;
      // align-items: center;
      align-items: flex-start;
      font-size: 16px;
      font-weight: bold;
      color: #000000;
    }
    .dt:hover {
      color: #ff7b0b;
    }
    .dd {
      display: flex;
      width: 800px;
      margin-left: 10px;
      flex-wrap: wrap;
      border-bottom: 1px dotted #e5e5e5;

      // padding-top: 23px;
      a {
        display: flex;
        align-items: flex-start;
        height: 41px;
        font-size: 14px;
        // align-items: center;

        margin-right: 40px;
        &:hover {
          color: #ff7b0b;
        }
      }
    }
    &:nth-last-child(1) {
      .dd {
        border-bottom: 0px dotted #e5e5e5;
      }
    }
  }
}
.warp {
  width: 100%;
  max-width: 1612px;
  margin: 0 auto;
  height: auto;
}
.tuijianModel {
  width: 100%;
  height: 163px;
  display: flex;
  margin-bottom: 40px;
  background: "../../assets/images/tuituikuan.png";
  .tuijian {
    width: 100%;
    height: 163px;
    background: linear-gradient(
      279deg,
      rgba(255, 255, 255, 0) 0%,
      #ffd2a9 100%
    );
    .beijing {
      width: auto;
      height: 162px;
      background: url("../../assets/images/zhutuikuan.png") no-repeat;
      background-size: auto 162px;
    }
    .image-button-prev1 {
      margin-left: 180px;
      margin-top: -90px;
      border-radius: 15px;
      background: #f77b0b;
      border: 1px solid #f77b0b;
      width: 24px;
      height: 24px;
    }
    .image-button-next1 {
      width: 24px;
      height: 24px;
      margin-left: auto;
      margin-top: -90px;
      border-radius: 15px;
      background: #f77b0b;
      border: 1px solid #f77b0b;
    }
    >>> .anticon svg {
      display: inline-block;
      margin-left: 4px;
      margin-top: 4px;
    }
  }
  .lunbo {
    position: relative;
    width: 1200px;
    height: 163px;

    >>> .cel {
      margin-top: 5px;
    }
  }
}
.productDetail-container {
  background-color: #f5f5f5;
  overflow: auto;
}
.classfiy {
  padding-top: 30px;
  height: auto;
}
.innerclassify {
  text-align: center;
  // padding-top: 30px;
  // background: white;
}
.swiper-button-prev {
  width: 35px;
  height: 35px;
  background: #fde5ce;
  color: #f77b0b;
  font-size: 28px;
  text-align: center;
  line-height: 35px;
  border-radius: 50%;
}
.swiper-button-next {
  width: 35px;
  height: 35px;
  background: #fde5ce;
  color: #f77b0b;
  font-size: 28px;
  text-align: center;
  line-height: 35px;
  border-radius: 50%;
}
.productBox {
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 21px 45px;
  .productConcise {
    margin-bottom: 60px;
    display: flex;

    .swiper-box {
      height: 590px;
      width: 31%;

      margin-right: 37px;
      box-sizing: border-box;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .server {
        line-height: 22px;
        margin-right: 30px;
        span {
          img {
            width: 22px;
            height: 22px;
            margin-right: 5px;
          }
        }
      }
      .favoritesBtn {
        width: 80px;
        height: 22px;
        display: flex;
        align-items: center;
        // background: #FFFFFF;
        // border: 1px solid #CCCCCC;
        text-align: center;
        margin-left: 10px;
        cursor: pointer;
        img {
          margin-right: 5px;
        }
        i {
          color: #666666;
          display: block;
          // margin-top: 2px;
        }
        span {
          display: block;
          font-size: 13px;
          color: #333333;
          padding-top: 3px;
        }
        & > span:nth-child(1):before {
          color: #f2c222;
          font-size: 22px;
          margin-right: 4px;
        }
      }
      .swiper-slide {
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        &.slide-1 {
          background-image: url("../../../static/image/tu1@2x.png");
        }
        &.slide-2 {
          background-image: url("../../../static/image/tu3@2x.png");
        }
        &.slide-3 {
          background-image: url("../../../static/image/tup2@2x.png");
        }
        &.slide-4 {
          background-image: url("../../../static/image/likeProduct1.png");
        }
        &.slide-5 {
          background-image: url("../../../static/image/poornetwork@2x.png");
        }
      }
      .gallery-top {
        height: 82%;
        width: 100%;
        margin-bottom: 7%;
      }
      .swiperThumbsLeft {
        width: 100%;
        box-sizing: border-box;
        padding: 0 5%;
        height: 11%;
        box-sizing: border-box;
        .thumbsBox {
          width: 100%;
          height: 100%;
          position: relative;
          .swiper-button-prev,
          .swiper-button-next {
            position: absolute;
            left: 45px;
            background: none;
            width: 32px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            background: #999999;
            color: #ffffff;
          }
          .swiper-button-prev {
            position: absolute;
            top: -30px;
          }
          .swiper-button-next {
            position: absolute;
            top: initial;
            bottom: -50px;
          }
        }
      }
      .image-button-prev {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        width: 24px;
        height: 58px;
        left: -26px;
        top: 0;
        cursor: pointer;
        color: #f77b0b;
        background: #fff;
        font-size: 20px;
        transition: all 0.5s;
      }
      .image-button-next {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        width: 24px;
        height: 58px;
        right: -26px;
        top: 0;
        cursor: pointer;
        color: #f77b0b;
        background: #fff;
        font-size: 20px;
        transition: all 0.5s;
      }
      .image-button-next:hover,
      .image-button-prev:hover {
        // background: #f7790b4b;
        color: #f7790b8e;
      }
      .gallery-thumbs {
        position: relative;
        width: 100%;
        height: 100%;
      }
      .gallery-thumbs .swiper-slide {
        // width: 100%;
        opacity: 0.8;
        margin-right: 10px;
        background-size: 90% auto;
        overflow: hidden;
        img {
          display: inline-block;
          width: 100%;
        }
      }
      .gallery-thumbs .swiper-slide-active {
        // opacity: 1;
        border: 1px solid $mainColor;
        box-sizing: border-box;
      }
    }
    .proDuctInfo {
      height: 100%;
      flex: 1;
      .productTit {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }
      .introduction {
        color: #999999;
        font-size: 14px;
        line-height: 30px;
        margin: 10px 0;
      }
      .priceDataInfo {
        // background: #FFF8F2;
        // height: auto;
        .groupBuyInfo {
          display: flex;
          justify-content: space-between;
          background: #ff6b63;
          height: 32px;
          align-items: center;
          padding: 0 16px;
          .groupLeft {
            display: flex;
            color: #ffffff;
            align-items: center;
            i {
              font-size: 22px;
              margin-right: 5px;
            }
            span {
              font-family: YouSheBiaoTiHei;
              font-style: italic;
              font-weight: bold;
            }
          }
          .groupRight {
            color: #ffffff;
          }
          .countdown {
            display: flex;
            font-size: 14px;
            color: #ffffff;
            .countdownTit {
              line-height: 20px;
              margin-right: 5px;
            }
            .timeDown {
              span {
                display: inline-block;
                text-align: center;
                height: 20px;
                line-height: 20px;
              }
              .time {
                min-width: 20px;
                background-color: #fff;
                color: #ff6b63;
              }
            }
          }
        }
        .priceSpike {
          display: flex;
          margin-top: 15px;
          padding: 0 15px;
          justify-content: space-between;
          .priceSpikeLeft {
            display: flex;
            color: #ec4b42;
            align-items: center;
            font-size: 16px;
            b {
              color: $mainColor;
              font-size: 22px;
              margin-right: 10px;
            }
            span {
              font-size: 16px;
              font-weight: 400;
              text-decoration: line-through;
              color: #666666;
            }
          }
          .priceSpikeRight {
            display: flex;
            align-items: center;
            span {
              margin-right: 15px;
              color: #999999;
              font-size: 14px;
            }
            >>> .el-progress {
              box-sizing: border-box;
              width: 100px;
              height: 10px;
              border-radius: 0;
              border: 1px solid #ff736c;
              background: #f5f5f5;
              .el-progress-bar {
                display: block;
                height: 100%;
                .el-progress-bar__inner {
                  border-radius: 0;
                  height: 100%;
                }
                .el-progress-bar__outer {
                  border-radius: 0;
                  height: 100% !important;
                }
                .el-progress-bar__innerText {
                  display: none;
                }
              }
            }
          }
        }
        .promotionInfo {
          padding: 30px 16px 5px 0;
          & > span:nth-child(1) {
            font-size: 14px;
            color: #606266;
            margin-right: 16px;
          }
          span:nth-child(2) {
            color: #ff4747;
            font-size: 26px;
            font-weight: bold;
          }
          // span:nth-child(3) {
          //   font-size: 16px;
          //   color: #666666;
          //   text-decoration: line-through;
          // }
        }

        .proDiscount {
          padding: 2px 0 16px;
          max-height: 112px;
          overflow-y: auto;
          box-sizing: border-box;
          .discountInfo {
            span:nth-child(1) {
              font-size: 16px;
              color: #999999;
            }
            span:nth-child(2) {
              font-size: 14px;
              color: $mainColor;
              border: 1px solid $mainColor;
              padding: 0 2px;
              border-radius: 4px;
            }
            span:nth-child(3) {
              font-size: 14px;
              color: #666666;
            }
          }
          .activityLabel {
            padding-left: 20px;
            margin-bottom: 20px;
            span:nth-child(1) {
              font-size: 14px;
              color: $mainColor;
              border: 1px solid $mainColor;
              padding: 1px 2px;
              border-radius: 4px;
            }
            span:nth-child(2) {
              font-size: 14px;
              color: #666666;
            }
            span:nth-child(3) {
              font-size: 14px;
              color: $mainColor;
              text-decoration: underline;
              cursor: pointer;
            }
          }
          .activityLabel:last-child {
            margin-bottom: 0;
          }
        }
      }
      .proDescribeTit-parent {
        display: flex;
      }
      .proDescribeTit {
        color: #606266;
        font-size: 14px;
        margin: 18px 16px 18px 0;
      }
      .proDescribeTit + p {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }
      .productNumber {
        .proDescribeTit {
          color: #333333;
        }
      }
      .productColor {
        .proColorList {
          display: flex;
          div {
            border: 1px solid #ffffff;
            padding: 4px;
            margin-right: 15px;
            cursor: pointer;
            span {
              display: block;
              height: 37px;
              width: 37px;
              border: 1px solid #eeeeee;
              img {
                width: 100%;
              }
            }
          }
          // div.colorActive {
          // }
        }
      }
      .sku-box {
        margin-bottom: 13px;
        ul {
          li {
            p {
              &:nth-child(2) {
                span {
                  display: inline-block;
                  padding: 0 18px;
                  height: 37px;
                  line-height: 37px;
                  // border-radius: 5px;
                  text-align: center;
                  color: #333333;
                  font-size: 14px;
                  // background: #efefef;
                  margin: 5px 9px;
                  // margin-bottom: 15px;
                  cursor: pointer;
                  background: #f5f5f5 !important;
                  border-radius: 2px;
                }
                .selected-item {
                  background: rgba(247, 123, 11, 0.15) !important;
                  border-radius: 2px;
                  // background: $mainColor;
                  color: #f77b0b;
                }
              }
            }
          }
        }
        .table-container {
          display: flex;
          margin-top: 20px;
          min-width: 900px;
          & > span {
            display: flex;
            margin-right: 25px;
            padding-top: 10px;
          }
          & > div {
            flex: 1;
          }
          .table-hidden {
            height: 332px;
            overflow: hidden;
          }
          .ant-table-wrapper {
            flex: 1;
          }
          .table-hidden-btn {
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            background-color: rgb(255, 255, 255);
            transition: all 0.5s;
            border-left: 1px solid #e8e8e8;
            border-right: 1px solid #e8e8e8;
            span {
              font-size: 26px;
            }
          }
          .table-hidden-btn:hover {
            background-color: rgb(250, 250, 250);
          }
          .total-info {
            display: flex;
            height: 44px;
            background-color: #f1f2f7;
            align-items: center;
            // justify-content: space-between;
            font-size: 16px;
            & > span:nth-child(1) {
              width: 150px;
              text-align: center;
              margin-right: 150px;
            }
            & > span:nth-child(1),
            & > span:nth-child(2) {
              text-align: center;
              color: #ff4747;
              font-weight: bolder;
            }
            span:last-child {
              margin-left: auto;
              color: #333333;
              width: 200px;
              text-align: center;
            }
          }
        }
      }
      .initBuyNumBox {
        & > span:nth-child(1) {
          color: #606266;
          font-size: 14px;
          display: inline-block;
          width: 53px;
          margin-top: 17px;
        }
        & > span:nth-child(2) {
          color: #333333;
          font-size: 14px;
        }
      }
      .initBuyNumBox_bottom {
        display: flex;
        align-items: center;
        margin-top: 23px;
        & > span:nth-child(1) {
          color: #606266;
          font-size: 14px;
          display: inline-block;
          width: 63px;
          margin-right: 17px;
          margin-top: 0;
        }
        & > span {
          display: flex;
          align-items: center;
          & > p {
            color: #333333;
            font-size: 14px;
            display: flex;
            align-items: center;
            span:nth-child(1) {
              // width: 16px;
              // height: 16px;
              // border:1px solid #F77B0B;
              // color: #F77B0B;
              // font-size: 13px;
              // border-radius: 50%;
              // display: flex;
              // justify-content: center;
              // align-items: center;
              // margin-right: 7px;
              display: flex;
              align-items: center;
              margin-right: 5px;
              img {
                max-width: 18px;
                max-height: 15px;
              }
            }
            span:nth-child(2) {
              margin-right: 31px;
            }
          }
        }
      }
      .productSize {
        .proSizeList {
          display: flex;
          span {
            padding: 0 10px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            color: #666666;
            font-size: 18px;
            background: #efefef;
            margin-right: 20px;
            cursor: pointer;
          }
          span.sizeActive {
            background: $mainColor;
            color: #ffffff;
          }
        }
      }
      .proNumberList {
        .el-input-number {
          width: 140px;
          margin-right: 25px;
        }
        b {
          font-size: 16px;
          font-weight: 500;
          color: $mainColor;
          padding: 0 5px;
        }
      }
      .btnBox {
        display: flex;
        align-items: center;
        margin-top: 30px;
        .buyBox {
          display: flex;
          span {
            background: #f77b0b;
            border-radius: 3px;
            border: 2px solid #f77b0b;
            // width: 135px;
            height: 57px;
            // background: #FF7800;
            display: block;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            // text-align: center;
            // line-height: 57px;
            cursor: pointer;
            padding: 0 27px;
            // width: 135px;
            // height: 42px;
            // line-height: 42px;
            // text-align: center;
            font-size: 16px;
            // color: $mainColor;
            // border: 1px solid $mainColor;
            margin-right: 27px;
            &:hover {
              cursor: pointer;
            }
          }
          span:nth-child(2) {
            background: #fff;
            color: #f77b0b;
          }
        }
        .favorites {
          display: flex;
          .StartGroup {
            background: #f77b0b;
            border-radius: 3px;
            border: 2px solid #f77b0b;
            width: 135px;
            height: 57px;
            // background: #FF7800;
            display: block;
            color: #ffffff;
            text-align: center;
            line-height: 57px;
            cursor: pointer;
            padding: 0 27px;
          }
          .oddBuy {
            width: 135px;
            height: 42px;
            display: block;
            box-sizing: border-box;
            color: $mainColor;
            border: 1px solid $mainColor;
            margin-right: 10px;
            text-align: center;
            line-height: 42px;
            cursor: pointer;
          }
        }
        .noStock {
          display: flex;
          span {
            width: 135px;
            height: 42px;
            background: #999999;
            display: block;
            color: #ffffff;
            text-align: center;
            line-height: 42px;
          }
        }
      }
    }
  }
  >>> .el-tabs--border-card {
    box-shadow: none;
    border: none;
  }
  .productDetail {
    width: 80%;
    float: right;
    // padding-top: 40px;
    .detailTabs {
      margin-bottom: 30px;
      height: 46px;
      line-height: 46px;
      border: 1px solid #e5e5e5;
      background: #f6f6f6;
      display: flex;
      span {
        padding: 0 30px;
        border-right: 1px solid #e5e5e5;
        cursor: pointer;
        color: #333333;
        font-size: 16px;
      }
      .compActive {
        background: #ffffff;
      }
    }
    .detailBox {
      // margin-bottom: 100px;
      display: flex;
      justify-content: center;
      .detailInfoBox {
        width: 100%;
        float: left;
        min-height: 600px;
        // border-right: 1px solid #CACACA;
      }
      .detailCont >>> img {
        // 修改v-html渲染的样式
        max-width: 100%;
        height: auto;
      }
      .detailCont >>> ul {
        // 修改v-html渲染的样式
        list-style-type: none;
      }
      .likeProductBox {
        width: 22%;
        float: left;
        padding-left: 44px;
      }
    }
  }
  .shopBufen {
    // float: left;
    // margin-top: 50px;
    margin-right: 40px;
    .wenben {
      font-size: 20px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #333333;
      line-height: 26px;
    }
    .tubiao {
      width: 24px;
      height: 24px;
      margin-left: 20px;
    }
  }
  .information {
    position: absolute;
    top: 50px;
    left: 10px;
    display: flex;
    width: 100%;
    padding-top: 10px;
    padding-left: 20px;
    width: auto;
    height: auto;
    .a {
      width: 80px;
      height: 27px;
    }
    .b {
      width: 14px;
      height: 17px;
      margin-left: 10px;
    }
    .c {
      padding-top: 6px;
      margin-left: 10px;
    }

    .e {
      padding-top: 6px;
      margin-left: 20px;
    }
  }
  .d {
    margin-top: -1px;
  }
  .bottom {
    background: white;
  }
  .topModel {
    display: flex;
    line-height: 56px;
    text-align: center;
    background: #f6f6f6;
    .shopMingzi {
      // width: 130px;
      // float: left;
      padding-left: 25px;
    }
    .shopTubiao {
      width: 24px;
      height: 24px;
      // float: right;
      padding-right: 20px;
    }
  }
  .tiaozhuan {
    display: flex;
    margin-top: 30px;
    margin-bottom: 20px;
    padding-left: 20px;
  }
  .jindainguang {
    width: 120px;
    height: 48px;
    background: #f6f6f6;
    text-align: center;
    line-height: 48px;
    &:hover {
      background: #fdd9b7;
      // color:#fff;
    }
    // padding-top: 12px;
    // padding-left: 20px;
    margin-left: 2px;
  }
  .shoucang {
    margin-left: 20px;
    width: 120px;
    height: 48px;
    background: #f5f5f5;
    text-align: center;
    line-height: 50px;
    &:hover {
      background: #fdd9b7;
      // color:#fff;
    }
  }
  .jindian {
    background: #f6f6f6;
    margin: 20, 10px;
  }
  .pinList {
    margin-top: 50px;
    border: 1px solid #e5e5e5;
    .fightOrderTit {
      display: flex;
      height: 60px;
      line-height: 60px;
      padding: 0 20px;
      border-bottom: 1px solid #e5e5e5;
      i {
        color: $mainColor;
        font-size: 28px;
      }
      span {
        color: #666666;
        font-size: 16px;
        margin-left: 10px;
      }
    }
    .pinListBox {
      padding: 0 30px;
      display: flex;
      // align-items: flex-start;
      flex-wrap: wrap;
      height: 110px;
      overflow-y: auto;
      .pinItem {
        flex: 0 0 33.33%;
        display: flex;
        align-items: center;
        margin: 25px 0;
        .Avatar {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 12px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .pinUserInfo {
          width: 125px;
          margin-right: 45px;
          span {
            display: block;
            font-size: 14px;
            b {
              font-weight: normal;
              color: $mainColor;
              letter-spacing: 3px;
            }
          }
          span:nth-child(1) {
            color: #333333;
            margin-bottom: 5px;
          }
          span:nth-child(2) {
            color: #666666;
            margin-bottom: 5px;
          }
          span:nth-child(3) {
            color: #999999;
          }
        }
        .pinBtn {
          width: 120px;
          height: 42px;
          border: 1px solid #ff7800;
          text-align: center;
          line-height: 42px;
          cursor: pointer;
          font-size: 16px;
          color: $mainColor;
        }
      }
    }
  }
}
.pinListBox::-webkit-scrollbar {
  width: 4px;
  height: 16px;
  background-color: #f5f5f5;
}
/*定义滚动条轨道 内阴影+圆角*/
.pinListBox::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  border-radius: 0px;
  background-color: #ffffff;
}
/*定义滑块 内阴影+圆角*/
.pinListBox::-webkit-scrollbar-thumb {
  border-radius: 0px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #e3e3e3;
}
.shop {
  height: auto;
  background: #fff;

  margin-top: 2px;
  .shopLogo {
    cursor: pointer;
    width: 76px;
    height: 76px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-left: 85px;
    img {
      width: 100%;
    }
    margin-right: 17px;
  }
  .shopInfo-box {
    width: 100%;
    cursor: pointer;
    margin-top: 10px;
    // height: 76px;
    display: flex;
    // background-color: #f5f5f5;
    // margin: 40px 20px 20px 0;
    justify-content: space-between;
    .shopName {
      cursor: pointer;
      font-size: 28px;
      font-weight: bold;
      color: #333333;
    }
    span {
      font-size: 14px;
      color: #606266;
      display: flex;
      align-items: center;
      img {
        width: 16px;
        margin-right: 4px;
      }
      img:first-child {
        margin-left: 12px;
      }
    }
  }
  .shopInfo {
    width: 200px;
    padding-left: 70px;
    .favoritesBox {
      display: flex;
      align-items: center;
      img {
        margin-right: 5px;
      }
    }
  }
  .shopName {
    font-size: 30px;
    font-weight: bold;
    cursor: pointer;
  }
}
.classify-bar {
  height: 38px;
  background: #2e2c2c;
  display: flex;
  align-items: center;
  padding: 0 85px;
  color: #fff;
  span {
    cursor: pointer;
    margin-right: 58px;
  }
  span:last-child {
    margin-right: 0;
  }
  span:hover {
    color: #f77b0b;
  }
}
>>> video::-internal-media-controls-download-button {
  display: none;
}
>>> video::-webkit-media-controls-enclosure {
  overflow: hidden;
}
>>> video::-webkit-media-controls-panel {
  width: calc(100% + 30px);
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 300px;
  .classify-outer {
  }
}
.xinxi {
  background: white;
  border: 1px solid #e5e5e5;
  width: 300px;
}
.el-card {
  box-shadow: none !important;
}
>>> .el-card__header {
  padding: 18px 20px;
  border-bottom: 1px solid #ebeef5;
  -webkit-box-sizing: border-box;
  background: #f6f6f6 !important;
  box-sizing: border-box;
  font-size: 20px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #333333;
  line-height: 26px;
}
>>> .el-card__body {
  padding: 20px;
  font-size: 20px;
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #333333;
  line-height: 19px;
}
//更改树形控件图标
.el-tree {
  /deep/ .el-icon-caret-right:before {
    // 未展开
    content: "\e7a0";
    font-size: 18px;
  }
  /deep/ .expanded:before {
    // 展开
    content: "\e7a2";
    font-size: 18px;
  }
  /deep/ .expanded {
    // 展开不旋转
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}

//所有控件
// >>> video::-webkit-media-controls-enclosure{
//     display: none;
// }

.toutou {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 152px;
  // position: fixed;

  .logo {
    width: 300px;
    cursor: pointer;
    /* padding-left: 30px; */
  }

  .menu {
    cursor: pointer;
    /* padding: 29px 0 0 0; */
    display: flex;
    align-items: center;
    padding-left: 30px;
    cursor: pointer;
    margin-top: -24px;

    .menu-flag {
      cursor: pointer !important;
      height: 46px;
      padding: 10px 20px;
      border: 1px solid #e5e5e5;
      border-radius: 2px;
      /* background: linear-gradient(180deg, #ff871b 0%, #ff5523 100%); */
      line-height: 46px;
      /* border-radius: 8px 8px 0px 0px; */
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: 20px;
      cursor: default;
      position: relative;
      & > div {
        display: flex;
        align-items: center;
      }
      .anticon-menu {
        font-size: 24px;
        margin-right: 27px;
      }
      .icon-The-editor-02 {
        transition: all 0.3s;
        transform: rotate(0);
      }
      .turnDown {
        transform: rotate(90deg);
        transition: all 0.3s;
      }
      .turnDown2 {
        transform: rotate(0);
        transition: all 0.3s;
      }
      .classify-outer {
        position: absolute;
        left: 0px;
        top: 54px;
        // width: 315px;
        padding: 0;
        /* height: 0; */
        // overflow: hidden;
        //  transition: none;
        z-index: 2;
      }
      .showClassify {
        /* height: 717px; */
      }
    }
    & > ul {
      height: 55px !important;
      line-height: 55px;
    }
    li {
      display: inline-block;
      line-height: 28px;
      a {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        display: block;
        cursor: pointer;
        padding: 0 63px 0 0;
        &:hover {
          color: $mainColor;
        }
      }
      .active {
        color: $mainColor;
      }
    }
    li:first-child {
      padding-left: 46px;
    }
  }
  .showClassify {
    height: 700px;
    border: 1px solid #e5e5e5;
  }
  .shopfl {
    text-align: center;
    /* margin-top: 10px;
      margin-left: 30px; */
    font-size: 20px;
    padding: 0 60px;
  }
  >>> .searchright {
    /* width: 633px; */
    height: 61px;
    display: flex;
    border-radius: 8px;
    display: flex;
    margin-top: 3px;
    justify-content: right;
    /* border: 1px solid #f77b0b; */
    padding-left: 150px;
    .shuru {
      height: 61px;
      width: 700px;
    }
    .bendain {
      width: 112px;
      height: 65px;
      margin-left: 7px;
    }
    .bdBtn {
      background: #333333;
      height: 61px;
      width: 112px;
      font-size: 20px;
      border-radius: 8px !important;
    }
    .quanzhan {
      margin-left: -8px;
      z-index: 500;
    }
  }
  .souzj {
    margin-left: 20px;
  }
  .info {
    border-radius: 8px;
  }

  .menu-flag {
    cursor: pointer;
    text-align: center;
  }
  .serachBtn {
    float: right;
  }

  .menu {
    /* padding: 29px 0 0 0; */
    display: flex;
    align-items: center;
    padding-left: 30px;

    .menu-flag {
      height: 46px;
      padding: 10px 20px;
      border: 1px solid #e5e5e5;
      border-radius: 2px;
      /* background: linear-gradient(180deg, #ff871b 0%, #ff5523 100%); */
      line-height: 46px;
      /* border-radius: 8px 8px 0px 0px; */
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: 20px;
      cursor: default;
      position: relative;
      & > div {
        display: flex;
        align-items: center;
      }
      .anticon-menu {
        font-size: 24px;
        margin-right: 27px;
      }
      .icon-The-editor-02 {
        transition: all 0.3s;
        transform: rotate(0);
      }
      .turnDown {
        transform: rotate(90deg);
        transition: all 0.3s;
      }
      .turnDown2 {
        transform: rotate(0);
        transition: all 0.3s;
      }
      .classify-outer {
        position: absolute;
        left: 0px;
        top: 55px;
        // width: 100%;
        padding: 0;
        /* height: 0; */
        // overflow:auto;
        // transition: all 0.3s;
        z-index: 2;
      }
      .showClassify {
        /* height: 717px; */
      }
    }
    & > ul {
      height: 55px !important;
      line-height: 55px;
    }
    li {
      display: inline-block;
      line-height: 28px;
      a {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        display: block;
        cursor: pointer;
        padding: 0 63px 0 0;
        &:hover {
          color: $mainColor;
        }
      }
      .active {
        color: $mainColor;
      }
    }
    li:first-child {
      padding-left: 46px;
    }
  }
  >>> .shop1 {
    height: 133px;
    width: 100%;
    /* margin-left: 40px; */
    // margin: 20px 0;
    padding: 20px 30px;
    display: flex;
    justify-content: space-between;
  }
  .shopLogo {
    width: 76px;
    height: 76px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-left: 85px;
    img {
      width: 100%;
    }
    margin-right: 17px;
  }
  .shopInfo-box {
    display: flex;
    // margin-top: 20px;
    // flex-direction: column;
    // justify-content: space-around;
    .shopName {
      cursor: pointer;
      font-size: 30px;
      font-weight: bold;
      color: #333333;
    }
    span {
      font-size: 14px;
      color: #606266;
      display: flex;
      align-items: center;
      img {
        width: 16px;
        margin-right: 4px;
      }
      img:first-child {
        margin-left: 12px;
      }
    }
  }
  .shopInfo {
    width: 200px;
    padding-left: 70px;
    .favoritesBox {
      display: flex;
      align-items: center;
      img {
        margin-right: 5px;
      }
    }
  }
  .shopName {
    cursor: pointer;
    font-size: 30px;
    font-weight: bold;
  }
  /* >>> .store .block11[data-v-3fb1a7fa] {
      padding-left: 1100px !important;
    } */
}
.shopHeard {
  margin-left: 60px;
  // display: flex;
}
.info35 {
  width: 96px;
  height: 21px;
  display: block;
  margin-left: -10px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
  font-family: MicrosoftYaHei;
  white-space: nowrap;
  line-height: 21px;
  margin-top: 3px;
}

.classify {
  margin-right: 20px;
  background-color: #fff;
  display: flex;
  padding: 20px;
  font-size: 16px;
  &:nth-child(1) {
    border-bottom: 1px dotted #e5e5e5;
  }
  &:nth-child(2) {
    border-bottom: 1px dotted #e5e5e5;
  }
  .fontB {
    font-size: 16px;
    line-height: 30px;
    /* font-weight: bold; */
    margin-right: 10px;
    color: #2c2b2b;
  }
  width: 100%;
  .xiangguan {
    /* height:50px;
    line-height: 50px; */
    margin-left: 20px;
    text-align: left;
    width: 100px;
    color: #666666;
  }
  .text {
    margin-right: 30px;
    color: #2c2b2b;
    /* font-weight: bold; */

    .classifyname {
      width: 60%;
    }
  }
}
.renzheng {
  width: 80px;
  height: 27px;
  margin-top: 10px;
  margin-right: 20px;
}
.information {
  height: 35px;
  display: flex;
  // margin-top: 10px;
  align-items: center;
  position: relative;

  .qiye {
    width: 18px;
    // height: 24px;

    // margin-left: 20px;
    margin-top: 10px;
  }
  .dingwei {
    height: 17px;

    margin-left: 20px;
    /* margin-top: 7px; */
  }
  .gyl {
    width: 30px;
    height: 67px;
    background: #fff;
  }
  .qiyeAge {
    margin-left: 10px;
    margin-top: 10px;
    width: 50px;
    font-size: 16px !important;
  }
  .shangchengLogo {
    width: 298px;
    height: 67px;
  }
  .dizhi {
    font-size: 16px !important;
    margin-left: 10px;
    width: auto;
    margin-top: 9px;
    height: 30px;
  }
  .chanpin {
    font-size: 16px;
    margin-left: 10px;
    margin-top: 9px;
    width: 200px;
    height: 30px;
  }

  .infomokuai {
    position: absolute;
    left: 0;
    top: 30px;
    padding-top: -30px;
    z-index: 88;
  }
}
.guanzhu {
  z-index: 66;
  width: 64px;
  height: 28px;
  border-radius: 28px;
  text-align: center;
  line-height: 28px;
  color: rgba(255, 71, 71, 1);
  border: 1px solid rgba(255, 71, 71, 1);
  margin-left: 30px;
  margin-top: 9px;
  &:hover {
    cursor: pointer;
    background-color: rgba(255, 71, 71, 1);
    color: #fff;
  }
  .clearfix {
    display: flex;
    .a {
      margin-left: 10px;
      font-size: 20px;
    }
    .b {
      margin-left: 20px;
    }
    .c {
      margin-left: 20px;
      margin-top: 5px;
    }
  }
  .qiyerenzheng {
    display: flex;
    .d {
      margin-left: 20px;
    }
    .e {
    }
  }
}
.img1 {
  /* z-index: 406; */
  width: 50px;
  height: 50px;
  align-self: flex-start;
  margin-bottom: 5px;
}
.word63 {
  /* z-index: 403; */
  width: 64px;
  height: 24px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
  font-family: MicrosoftYaHei;
  white-space: nowrap;
  line-height: 21px;
  text-align: left;
  margin: 75px 0 0 629px;
}
.info34 {
  /* z-index: 404; */
  /* width: 104px; */
  /* height: 21px; */
  /* margin-left: -30px; */
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
  font-family: MicrosoftYaHei;
  white-space: nowrap;
  line-height: 21px;
  text-align: center;
  align-self: flex-end;
}
.block12 {
  z-index: 650;
  width: 96px;
  height: 74px;
  /* padding-left: 100px; */
  margin: 20px 0 0 20px;
  position: relative;
  .erweimamokuai {
    position: absolute;
    left: -200px;
    top: 80px;
    z-index: 199;
  }
}
.block11 {
  /* z-index: auto; */
  width: 100%;
  text-align: center;
  // height: 71px;
  // margin-top: 18px;
  margin-right: 80px;
  display: flex;
  justify-content: left;
}
>>> .el-tree-node {
  .el-tree-node__label {
    color: #000000 !important;
  }
}

>>> .el-tree-node__children {
  .el-tree-node__label {
    color: #333333 !important;
  }
}
>>> .el-tabs {
  height: 45px;
  /* background: url("../../assets/images/tabsBg.png"); */
  background-size: 100% auto;
  color: #fff;
  padding-left: 20px;
  line-height: 45px;
  /* margin-bottom: 15px; */
  .el-tabs__item.is-active {
    color: #f5deae;
    background: #534c3e;
    border-bottom: none;
  }
  .el-tabs__active-bar {
    background-color: #534c3e;
  }
  .el-tabs__item {
    height: 43px;
    margin-top: -2px !important;
    // margin: 0 20px;
    font-size: 16px;
    color: #ffffff;
    position: relative;
  }
  .el-tabs__item:hover {
    color: #f5deae;
    background: #534c3e;
  }
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs__nav-wrap {
    overflow: visible;
  }
  .el-tabs__header {
    border: none !important;
  }
  .el-tabs__nav-scroll {
    height: 45px;
    overflow: visible;
  }
}
.tabs {
  >>> .el-tabs__item {
    width: 150px !important;
    text-align: center;
  }
}
>>> #tab-contact {
  padding-right: 20px !important;
}
>>> #tab-index {
  padding-left: 20px !important;
}
// >>> .el-input__inner {
//   height: 61px;
//   font-size: 16px;
//   padding: 0 60px 0 52px;
//   border-radius: 8px;
// }
>>> .el-input--prefix .el-input__inner {
  // padding-left: 54px !important;
  height: 61px;
  font-size: 16px;
  padding: 0 60px 0 52px;
  border-radius: 8px;
  border: 1px solid #f77b0b;
}
.qzBtn {
  width: 112px;
  height: 61px;
  border-radius: 8px !important;
  margin-left: -8px;
  font-size: 20px;
  background: linear-gradient(90deg, #ff871b 0%, #ff5523 100%);
  border: 1px solid #f77b0b;
}
>>> .el-input__icon {
  height: 100%;
  width: 25px;
  font-size: 24px;
  margin-left: 10px;
  padding-top: 3px;
  text-align: center;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  line-height: 40px;
}

>>> .icon-shoucang1:before {
  content: "\E650";
  color: #f2c222;
  font-size: 16px;
  margin-right: 4px;
}
>>> .el-tree {
  /deep/ .el-icon-caret-right:before {
    // 未展开
    content: "\e7a0";
    font-size: 18px;
  }
  /deep/ .expanded:before {
    // 展开
    content: "\e7a2";
    font-size: 18px;
  }
  /deep/ .expanded {
    // 展开不旋转
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
</style>
<style scoped>
@media only screen and (max-width: 1080px) {
  .el-tab-box {
    height: 45px;
    background: url("../../assets/images/tabsBg.png") no-repeat 100%/100% !important;
  }
  .shopHeaderBj {
    background: url("../../assets/images/shopHeaderBg1080.png") no-repeat 100%/100%;
    height: 133px;
  }
}
@media only screen and (min-width: 1080px) {
  .el-tab-box {
    height: 45px;
    background: url("../../assets/images/tabsBg.png") no-repeat 100%/100% !important;
  }
  .shopHeaderBj {
    background: url("../../assets/images/shopHeaderBg1080.png") no-repeat 100%/100%;
    height: 133px;
  }
}
@media only screen and (min-width: 2200px) {
  .el-tab-box {
    height: 45px;
    background: url("../../assets/images/tabsBg2.png") no-repeat 100%/100% !important;
  }
  .shopHeaderBj {
    background: url("../../assets/images/shopHeaderBg2560.png") no-repeat 100%/100%;
    height: 133px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/product/productDetail.vue